// translations.ts
export const translations = {
  back: {
    en: "Back",
    zh: "返回",
  },
  recentUploads: {
    en: "Recent Uploads",
    zh: "最近上传",
  },
  endOfFinancialYear: {
    en: "End of Financial Year",
    zh: "财年底",
  },
  calendarYear: {
    en: "Calendar Year",
    zh: "日历年",
  },
  financialYear: {
    en: "Financial Year",
    zh: "财年",
  },
  salesScorecardYoYUsage: {
    en: "Sales Scorecard - Year On Year Usage",
    zh: "销售记分卡 - 逐年用量对比",
  },
  salesScorecardFinancialYear: {
    en: "Sales Scorecard - Financial Year",
    zh: "销售记分卡 - 财年",
  },
  searchArchivedOrders: {
    en: "Search Archived Orders",
    zh: "搜索存档订单",
  },
  orderNumberPlaceholder: {
    en: "Enter order number(s), separated by commas",
    zh: "输入订单号，多个订单号请用逗号分隔",
  },
  sampleRequest: {
    en: "Sample Request",
    zh: "样品申请",
  },
  jan: {
    en: "Jan",
    zh: "一月",
  },
  feb: {
    en: "Feb",
    zh: "二月",
  },
  mar: {
    en: "Mar",
    zh: "三月",
  },
  apr: {
    en: "Apr",
    zh: "四月",
  },
  may: {
    en: "May",
    zh: "五月",
  },
  jun: {
    en: "Jun",
    zh: "六月",
  },
  jul: {
    en: "Jul",
    zh: "七月",
  },
  aug: {
    en: "Aug",
    zh: "八月",
  },
  sep: {
    en: "Sep",
    zh: "九月",
  },
  oct: {
    en: "Oct",
    zh: "十月",
  },
  nov: {
    en: "Nov",
    zh: "十一月",
  },
  dec: {
    en: "Dec",
    zh: "十二月",
  },
  yesterday: {
    en: "Yesterday",
    zh: "昨天",
  },
  breakdown: {
    en: "Breakdown",
    zh: "明细",
  },
  monthly: {
    en: "Monthly",
    zh: "月度",
  },
  weekly: {
    en: "Weekly",
    zh: "周度",
  },
  daily: {
    en: "Daily",
    zh: "日度",
  },
  audExclGst: {
    en: "|| $AUD excl. GST",
    zh: "|| 澳元 (不含消费税)",
  },
  searchItemCustomerOrSalesPerson: {
    en: "Search item, customer or sales person...",
    zh: "搜索物品、客户或销售人员...",
  },
  addCriteria: {
    en: "Add criteria...",
    zh: "添加条件...",
  },
  reset: {
    en: "Reset",
    zh: "重置",
  },
  page: {
    en: "Page",
    zh: "页",
  },
  total: {
    en: "TOTAL",
    zh: "总计",
  },
  filteredRows: {
    en: "filtered rows",
    zh: "已过滤行",
  },
  rows: {
    en: "rows",
    zh: "行",
  },
  filters: {
    en: "FILTERS",
    zh: "筛选器",
  },
  year: {
    en: "Year",
    zh: "年份",
  },
  salesPerson: {
    en: "Sales Person",
    zh: "销售员",
  },
  invoiceDNDetail: {
    en: "Invoice DN Detail",
    zh: "发票与交货单明细",
  },
  invoiceLines: {
    en: "Invoice Lines",
    zh: "发票行",
  },
  dataUpTo: {
    en: "Data up to:",
    zh: "数据截至:",
  },
  resetFilter: {
    en: "Reset Filter",
    zh: "重置筛选",
  },
  searchItemCustomerSalesPerson: {
    en: "Search item, customer, sales person...",
    zh: "搜索物品、客户、销售人员...",
  },
  rowsPerPage: {
    en: "Rows per page:",
    zh: "每页行数:",
  },
  invoiceDate: {
    en: "Invoice Date",
    zh: "发票日期",
  },
  invoiceNo: {
    en: "Invoice No.",
    zh: "发票号码",
  },
  dnNo: {
    en: "DN No.",
    zh: "交货单号码",
  },
  valueUsd: {
    en: "Value ($)",
    zh: "金额 ($)",
  },
  deliverySuburb: {
    en: "Delivery Suburb",
    zh: "送货地区",
  },
  monthShort: {
    en: "Mth",
    zh: "月份",
  },
  dispatchSt: {
    en: "Dispatch St.",
    zh: "发货州",
  },
  deliverySt: {
    en: "Delivery St.",
    zh: "送货州",
  },
  dispatchState: {
    en: "Dispatch State",
    zh: "发货州",
  },
  deliveryState: {
    en: "Delivery State",
    zh: "送货州",
  },
  itemGroup: {
    en: "Item Group",
    zh: "物品组",
  },
  transferringIn: {
    en: "Transferring In\n(Local)",
    zh: "调入中 (当地的)",
  },
  orderReserved: {
    en: "Order\nReserved",
    zh: "订单预留",
  },
  english: {
    en: "English",
    zh: "英文",
  },
  chinese: {
    en: "Chinese",
    zh: "中文",
  },
  calendarMonth: {
    en: "Month",
    zh: "月",
  },
  calendarWeek: {
    en: "Week",
    zh: "周",
  },
  calendarDay: {
    en: "Day",
    zh: "日",
  },
  last7days: {
    en: "Last 7 Days",
    zh: "过去 7 天",
  },
  dateRange: {
    en: "Date Range",
    zh: "日期范围",
  },
  dateAll: {
    en: "Date: All",
    zh: "日期: 全部",
  },
  uploadedBy: {
    en: "Uploaded By",
    zh: "上传者",
  },
  createdDate: {
    en: "Created Date",
    zh: "创建日期",
  },
  attachmentManager: {
    en: "Attachment Manager",
    zh: "附件管理",
  },
  toolingCost: {
    en: "Tooling Cost",
    zh: "工装成本",
  },
  requestedBy: {
    en: "Requested By",
    zh: "请求人",
  },
  purpose: {
    en: "Purpose",
    zh: "目的",
  },
  requestId: {
    en: "Request ID",
    zh: "请求 ID",
  },
  downloadAll: {
    en: "Download All",
    zh: "全部下载",
  },
  downloadFailed: {
    en: "Download Failed",
    zh: "下载失败",
  },
  attachments: {
    en: "Attachments",
    zh: "附件",
  },
  couldNotLoadDeliveryNote: {
    en: "Could not load the delivery note.",
    zh: "无法加载交货单。",
  },
  documentDownloader: {
    en: "Document Downloader",
    zh: "文件下载器",
  },
  documents: {
    en: "Documents",
    zh: "文件",
  },
  printing: {
    en: "Printing...",
    zh: "打印中...",
  },
  printPdf: {
    en: "Print PDF",
    zh: "打印 PDF",
  },
  viewPdf: {
    en: "View PDF",
    zh: "查看 PDF",
  },
  noDeliveryNote: {
    en: "No delivery note available",
    zh: "无交货单可用",
  },
  podChepDoc: {
    en: "POD & CHEP Doc",
    zh: "POD 和 CHEP 文件",
  },
  viewFile: {
    en: "View File",
    zh: "查看文件",
  },
  remove: {
    en: "Remove",
    zh: "移除",
  },
  uploadPodChep: {
    en: "Select and Upload POD / CHEP File",
    zh: "选择并上传 POD / CHEP 文件",
  },
  takePhoto: {
    en: "Take Photo",
    zh: "拍照",
  },
  chooseFromGallery: {
    en: "Choose from Gallery",
    zh: "从相册选择",
  },
  cameraPermissionRequired: {
    en: "Camera permission is required",
    zh: "需要相机权限",
  },
  additionalImage: {
    en: "Additional Image",
    zh: "附加图片",
  },
  uploadAdditionalImage: {
    en: "Select and Upload Additional Image",
    zh: "选择并上传附加图片",
  },
  remarksDescription: {
    en: "Remarks / Description",
    zh: "备注 / 描述",
  },
  provideAdditionalDetails: {
    en: "Provide additional details or notes here...",
    zh: "在此处提供更多详细信息或注释...",
  },
  submit: {
    en: "Submit",
    zh: "提交",
  },
  submissionSuccessful: {
    en: "Submission Successful",
    zh: "提交成功",
  },
  submissionFailed: {
    en: "Submission Failed",
    zh: "提交失败",
  },
  couldNotReadImage: {
    en: "Could not read captured image",
    zh: "无法读取捕获的图像",
  },
  to: {
    en: "to",
    zh: "至",
  },
  readyByDate: {
    en: "Ready By Date",
    zh: "备货日期",
  },
  "Reserve Stock": {
    en: "Reserve Stock",
    zh: "预留库存",
  },
  "Reserve Stock Details": {
    en: "Reserve Stock Details",
    zh: "预留库存详情",
  },
  Appointments: {
    en: "Appointments",
    zh: "预约",
  },
  "Sales Scorecard": {
    en: "Sales Scorecard",
    zh: "销售记分卡",
  },
  "Order Reserved": {
    en: "Order\nReserved",
    zh: "订单预留",
  },
  accounts: {
    en: "Accounts",
    zh: "账户",
  },
  settings: {
    en: "Settings",
    zh: "设置",
  },
  logout: {
    en: "Logout",
    zh: "登出",
  },
  home: {
    en: "Home",
    zh: "主页",
  },
  help: {
    en: "Help",
    zh: "帮助",
  },
  searchPlaceholder: {
    en: "Search...",
    zh: "搜索...",
  },
  searchBar: {
    en: "Search Bar",
    zh: "搜索栏",
  },
  hubspot: {
    en: "Hubspot",
    zh: "集线器点",
  },
  reports: {
    en: "Reports",
    zh: "报告",
  },
  containers: {
    en: "Containers",
    zh: "集装箱",
  },
  operations: {
    en: "Operations",
    zh: "运营",
  },
  totalContainers: {
    en: "Total Containers",
    zh: "集装箱总数",
  },
  searchBy: {
    en: "Search by",
    zh: "搜索方式",
  },
  deliverTo: {
    en: "Deliver To",
    zh: "送货至",
  },
  container: {
    en: "Container",
    zh: "集装箱",
  },
  noDataAvailable: {
    en: "No Data Available",
    zh: "暂无数据",
  },

  delivery: {
    en: "Delivery",
    zh: "送货",
  },
  orderDelivery: {
    en: "Order/Delivery",
    zh: "订单/送货",
  },
  tracker: {
    en: "Tracker",
    zh: "追踪",
  },
  description: {
    en: "Description",
    zh: "说明",
  },
  packingNo: {
    en: "Packing #",
    zh: "装箱单号",
  },
  operationalScans: {
    en: "OperationalScans",
    zh: "操作扫描",
  },
  production: {
    en: "Production",
    zh: "生产",
  },
  accountSettings: {
    en: "Account Settings",
    zh: "账户设置",
  },
  userSettings: {
    en: "User Settings",
    zh: "用户设置",
  },
  usersManagement: {
    en: "Users Management",
    zh: "用户管理",
  },
  organizationSettings: {
    en: "Organisation Settings",
    zh: "组织设置",
  },
  organizationManagement: {
    en: "Organisation Management",
    zh: "组织管理",
  },
  notifications: {
    en: "Notifications",
    zh: "通知",
  },
  signOut: {
    en: "Sign Out",
    zh: "登出",
  },
  productTrackerReport: {
    en: "Product Tracker Report",
    zh: "产品追踪报告",
  },
  manageContainer: {
    en: "Manage Container",
    zh: "管理集装箱",
  },
  customerOrderSummaryReport: {
    en: "Customer Order Summary Report",
    zh: "客户订单摘要报告",
  },
  producttrackerdetailsreport: {
    en: "ProductTrackerDetailsReport",
    zh: "产品追踪详情报告",
  },
  notification: {
    en: "Notification",
    zh: "通知",
  },
  dynamicWidth: {
    en: "Dynamic Width",
    zh: "动态宽度",
  },
  productionStockDetails: {
    en: "Production Stock Details",
    zh: "生产库存详情",
  },
  chinaShipmentReport: {
    en: "China Shipment Report",
    zh: "中国发货报告",
  },
  company: {
    en: "Company",
    zh: "公司",
  },
  multistepsGo: {
    en: "Multisteps GO",
    zh: "Multisteps GO",
  },
  kanbanpocscreen: {
    en: "KanbanPOCScreen",
    zh: "看板 POC 屏幕",
  },
  stockTransferReport: {
    en: "Stock Transfer Report",
    zh: "库存转移报告",
  },
  inventoryDetailReport: {
    en: "Inventory Detail Report",
    zh: "库存详情报告",
  },
  dynamicWidthScreen: {
    en: "Dynamic Width Screen",
    zh: "动态宽度屏幕",
  },
  containersManagement: {
    en: "Containers Management",
    zh: "集装箱管理",
  },
  teams: {
    en: "Teams",
    zh: "团队",
  },
  customerIssueReport: {
    en: "Customer Issue Report",
    zh: "客户问题报告",
  },
  globalShipmentReport: {
    en: "Global Shipment Report",
    zh: "全球发货报告",
  },
  customerOrderDashboard: {
    en: "Customer Order Dashboard",
    zh: "客户订单仪表板",
  },
  profile: {
    en: "Profile",
    zh: "个人资料",
  },
  customerStatusDetails: {
    en: "Customer Status Details",
    zh: "客户状态详情",
  },
  customerIssueScreen: {
    en: "Customer Issue Screen",
    zh: "客户问题屏幕",
  },
  kanbanPoc: {
    en: "Kanban POC",
    zh: "看板 POC",
  },
  prepayOrderRequest: {
    en: "Prepay Order Request",
    zh: "预付订单请求",
  },
  customerissuereport: {
    en: "CustomerIssueReport",
    zh: "客户问题报告",
  },
  customerassignproductsreport: {
    en: "Customer Assign Products Report",
    zh: "客户分配产品报告",
  },
  customerAssignProductsReport: {
    en: "CustomerAssignProductsReport",
    zh: "客户分配产品报告",
  },
  artwork: {
    en: "Artwork",
    zh: "艺术作品",
  },
  multistepsGoResetPassword: {
    en: "Multisteps GO | Reset Password",
    zh: "Multisteps GO | 重置密码",
  },
  chinaTrackerReport: {
    en: "China Tracker Report",
    zh: "中国追踪报告",
  },
  customerIssueSummaryReport: {
    en: "Customer Issue Summary Report",
    zh: "客户问题摘要报告",
  },
  globalshipment: {
    en: "GlobalShipment",
    zh: "全球发货",
  },
  customerOrderScreen: {
    en: "Customer Order Screen",
    zh: "客户订单屏幕",
  },
  users: {
    en: "Users",
    zh: "用户",
  },
  producttracker: {
    en: "ProductTracker",
    zh: "产品追踪",
  },
  createCompany: {
    en: "Create Company",
    zh: "创建公司",
  },
  inventoryOverviewDetails: {
    en: "Inventory Overview Details",
    zh: "库存总览详情",
  },
  globalshipmentdetailsreport: {
    en: "GlobalShipmentDetailsReport",
    zh: "全球发货详情报告",
  },
  manageOperations: {
    en: "Manage Operations",
    zh: "运营管理",
  },
  itemsManagement: {
    en: "Items Management",
    zh: "物品管理",
  },
  scanResults: {
    en: "Scan Results",
    zh: "扫描结果",
  },
  productionDashboard: {
    en: "Production Dashboard",
    zh: "生产仪表板",
  },
  addArtwork: {
    en: "Add Artwork",
    zh: "添加艺术作品",
  },
  reserveOrderRequest: {
    en: "Reserve Order Request",
    zh: "预留订单请求",
  },
  kanbanPocReport: {
    en: "Kanban POC Report",
    zh: "看板 POC 报告",
  },
  chinashipment: {
    en: "ChinaShipment",
    zh: "中国发货",
  },
  chinatracker: {
    en: "ChinaTracker",
    zh: "中国追踪",
  },
  containersStatus: {
    en: "Containers Status",
    zh: "集装箱状态",
  },
  operationsStatus: {
    en: "Operations Status",
    zh: "运营状态",
  },
  addContainer: {
    en: "Add Container",
    zh: "添加集装箱",
  },
  addOperations: {
    en: "Add Operations",
    zh: "添加运营",
  },
  addOperation: {
    en: "Add Operation",
    zh: "添加运营",
  },
  trackerDashboardReport: {
    en: "Tracker Dashboard Report",
    zh: "追踪仪表板报告",
  },
  trackerdashboard: {
    en: "TrackerDashboard",
    zh: "追踪仪表板",
  },
  artworkManagement: {
    en: "Artwork Management",
    zh: "艺术作品管理",
  },
  operationsDetails: {
    en: "Operations Details",
    zh: "运营详情",
  },
  chinatrackerdetailsreport: {
    en: "ChinaTrackerDetailsReport",
    zh: "中国追踪详情报告",
  },
  customerorderreport: {
    en: "CustomerOrderReport",
    zh: "客户订单报告",
  },
  customerordersummaryreport: {
    en: "CustomerOrderSummaryReport",
    zh: "客户订单摘要报告",
  },
  orderRequest: {
    en: "Order Request",
    zh: "订单请求",
  },
  chinaTracker: {
    en: "China Tracker",
    zh: "中国追踪",
  },
  customerissuedetailsreport: {
    en: "CustomerIssueDetailsReport",
    zh: "客户问题详情报告",
  },
  stockTransfer: {
    en: "Stock Transfer",
    zh: "库存调拨",
  },
  transferIn: {
    en: "Transfer In",
    zh: "调入",
  },
  transferOut: {
    en: "Transfer Out",
    zh: "调出",
  },
  operationsManagement: {
    en: "Operations Management",
    zh: "运营管理",
  },
  chinashipmentdetailsreport: {
    en: "ChinaShipmentDetailsReport",
    zh: "中国发货详情报告",
  },
  placeOrderRequest: {
    en: "Place Order Request",
    zh: "下订单请求",
  },
  customerOrderTracker: {
    en: "Customer Order Tracker",
    zh: "追踪客户订单",
  },
  chinaOrderTracker: {
    en: "China Order Tracker",
    zh: "追踪中国订单",
  },
  chinaTrackerPlanning: {
    en: "Order Planning",
    zh: "订单排程",
  },
  qldPlanning: {
    en: "QLD Planning",
    zh: "昆州排程",
  },
  chinaPlanning: {
    en: "China Planning",
    zh: "中国排程",
  },
  productionRuns: {
    en: "production runs",
    zh: "生产批次",
  },
  loadMoreData: {
    en: "Load More Data",
    zh: "加载更多数据",
  },
  incomingStatus: {
    en: "Incoming Status",
    zh: "传入状态",
  },
  trackerDashboard: {
    en: "Tracker Dashboard",
    zh: "追踪器仪表板",
  },
  // Customer Order Tracker
  orderNumber: {
    en: "Order No",
    zh: "订单号",
  },
  itemCode: {
    en: "Item Code",
    zh: "商品代码",
  },
  documentType: {
    en: "Document Type",
    zh: "文件类型",
  },
  customerRef: {
    en: "Customer Ref#",
    zh: "客户参考号",
  },
  deliveryAddress: {
    en: "Delivery Address",
    zh: "送货地址",
  },
  chinaItemCode: {
    en: "China Item Code",
    zh: "中国商品代码",
  },
  globalItemCode: {
    en: "Item Code",
    zh: "商品代码",
  },
  itemName: {
    en: "Item Name",
    zh: "商品名称",
  },
  customerName: {
    en: "Customer Name",
    zh: "客户名称",
  },
  orderDate: {
    en: "Order Date",
    zh: "订购日期",
  },
  orderQty: {
    en: "Order Qty",
    zh: "订单数量",
  },
  Qty: {
    en: "Qty",
    zh: "数量",
  },
  gwTotal: {
    en: "Gross Weight",
    zh: "毛重",
  },
  nwTotal: {
    en: "Net Weight",
    zh: "净重",
  },
  progress: {
    en: "Progress",
    zh: "进度",
  },
  requestDate: {
    en: "Request Date",
    zh: "请求日期",
  },
  location: {
    en: "Location",
    zh: "地点",
  },
  state: {
    en: "State",
    zh: "省份",
  },
  daysLeft: {
    en: "Days Left",
    zh: "剩余天数",
  },
  orderStatus: {
    en: "Order Status",
    zh: "订单状态",
  },
  actions: {
    en: "Actions",
    zh: "操作",
  },
  orderNo: {
    en: "Order No",
    zh: "订单号",
  },
  docNumbers: {
    en: "Doc Numbers",
    zh: "文件编号",
  },
  organization: {
    en: "Organization",
    zh: "组织",
  },
  requestType: {
    en: "Request Type",
    zh: "请求类型",
  },
  totalItems: {
    en: "Total Items",
    zh: "总项目",
  },
  orderInformation: {
    en: "Order Information",
    zh: "订单信息",
  },
  subOrganization: {
    en: "Sub Organization",
    zh: "子组织",
  },
  exportCsv: {
    en: "Export CSV",
    zh: "导出 CSV",
  },
  exportJson: {
    en: "Export JSON",
    zh: "导出 JSON",
  },
  orderItems: {
    en: "Order Items",
    zh: "订单项目",
  },
  qty: {
    en: "Qty",
    zh: "数量",
  },
  requiredDate: {
    en: "Required Date",
    zh: "需求日期",
  },
  perCarton: {
    en: "Per Carton",
    zh: "每箱",
  },
  perPallet: {
    en: "Per Pallet",
    zh: "每托盘",
  },
  documentNumber: {
    en: "Document Number",
    zh: "文件号码",
  },
  viewDnAttachment: {
    en: "View DN Attachment",
    zh: "查看交货单附件",
  },
  noDnAttachment: {
    en: "No DN attachment",
    zh: "无交货单附件",
  },
  appointment: {
    en: "Appointment",
    zh: "预约",
  },
  quickFilter: {
    en: "Quick Filter",
    zh: "快速过滤器",
  },
  totalDelivery: {
    en: "Total Delivery",
    zh: "送货总数",
  },
  portalOrderNo: {
    en: "Portal Order No",
    zh: "门户订单号",
  },
  documentNo: {
    en: "Document #",
    zh: "文件编号",
  },
  address: {
    en: "Address",
    zh: "地址",
  },
  reference: {
    en: "Reference",
    zh: "参考",
  },
  productGroup: {
    en: "Product Group",
    zh: "产品组",
  },
  deliveryQty: {
    en: "Delivery Qty",
    zh: "交货数量",
  },
  remainingQty: {
    en: "Remaining Qty",
    zh: "剩余数量",
  },
  pallets: {
    en: "Pallets",
    zh: "托盘",
  },
  date: {
    en: "Date",
    zh: "日期",
  },
  type: {
    en: "Type",
    zh: "类型",
  },

  updateShipment: {
    en: "Update Shipment",
    zh: "更新发货",
  },

  shipmentActions: {
    en: "Actions",
    zh: "安排",
  },

  // Incoming Statuses
  incoming: {
    en: "Incoming",
    zh: "传入",
  },
  approved: {
    en: "Approved",
    zh: "得到正式认可的",
  },
  rejected: {
    en: "Rejected",
    zh: "被拒绝",
  },
  revised_by_purchasing: {
    en: "REVISED BY PURCHASING",
    zh: "采购部修订",
  },

  // Quick Filters
  all: {
    en: "All",
    zh: "全部",
  },
  products: {
    en: "Products",
    zh: "产品",
  },
  states: {
    en: "States",
    zh: "州",
  },
  onHold: {
    en: "Onhold",
    zh: "搁置",
  },
  closed: {
    en: "Closed",
    zh: "关闭",
  },
  newOrder: {
    en: "New Order",
    zh: "新订单",
  },
  arrived: {
    en: "Arrived",
    zh: "到达的",
  },
  shipped: {
    en: "Shipped",
    zh: "已发货",
  },
  scheduled: {
    en: "Scheduled",
    zh: "已计划",
  },
  urgent: {
    en: "Urgent",
    zh: "加急",
  },
  rushOrder: {
    en: "Rush Order",
    zh: "加急订单",
  },
  orderPlaced: {
    en: "Order Placed",
    zh: "已下订单",
  },
  atRisk: {
    en: "At Risk",
    zh: "有风险订单",
  },
  planned: {
    en: "Planned",
    zh: "计划",
  },
  completed: {
    en: "Completed",
    zh: "完全的",
  },
  interrupted: {
    en: "Interrupted",
    zh: "被打断",
  },
  //China tracker
  onTime: {
    en: "On Time",
    zh: "准时交货",
  },
  delayed: {
    en: "Delayed",
    zh: "延迟",
  },
  msRef: {
    en: "MS No",
    zh: "MS订单号",
  },
  priorityOrder: {
    en: "Priority Order",
    zh: "优先订单",
  },

  high: {
    en: "High",
    zh: "高的",
  },

  normal: {
    en: "Normal",
    zh: "正常",
  },
  "eta port": {
    en: "ETA Port",
    zh: "预计到达港口",
  },
  "status & progress": {
    en: "Status & Progress",
    zh: "状态与进度",
  },
  "dates & timing": {
    en: "Dates & Timing",
    zh: "日期与时间",
  },
  identifiers: {
    en: "Identifiers",
    zh: "标识符",
  },
  "other information": {
    en: "Other Information",
    zh: "其他信息",
  },

  add: {
    en: "Add",
    zh: "添加",
  },

  delete: {
    en: "Delete",
    zh: "删除",
  },

  medium: {
    en: "Medium",
    zh: "中等的",
  },

  allocateProductionLine: {
    en: "Prod. Line",
    zh: "生产线",
  },
  artworkNo: {
    en: "Artwork No",
    zh: "贴纸编号",
  },
  qtyToShip: {
    en: "Qty to Ship",
    zh: "剩余未交数量",
  },
  fulfillmentPercent: {
    en: "Fulfilment %",
    zh: "订单履约率",
  },
  ausInventory: {
    en: "Aus Inventory",
    zh: "澳洲库存",
  },
  noData: {
    en: "No Data",
    zh: "没有资料",
  },
  run1: {
    en: "Run 1",
    zh: "生产批次 1",
  },
  run2: {
    en: "Run 2",
    zh: "生产批次 2",
  },
  plannedQuantity: {
    en: "Planned Quantity",
    zh: "计划生产数量",
  },
  artworkNumber: {
    en: "Artwork Number",
    zh: "贴纸编号",
  },
  addMoreRun: {
    en: "Add more run",
    zh: "增加生产次数",
  },
  reviewRejectedOrder: {
    en: "Review rejected order",
    zh: "审查被拒绝订单",
  },
  interruptRunOrder: {
    en: "Interrupt Run Order",
    zh: "中断运行",
  },
  resumeRunOrder: {
    en: "Resume Run Order",
    zh: "恢复运行",
  },
  interruptRunOrderNotice: {
    en: "Interrupting this run order will pause its execution and may impact downstream processes.",
    zh: "中断此运行将会暂停此订单执行，并可能会影响此订单往后的进程。",
  },
  resumeRunOrderNotice: {
    en: "This run order is currently interrupted. Resuming will return it to the normal execution flow.",
    zh: "此运行正处于中断状态。恢复后，它将返回正常的执行流程。",
  },
  productionLine: {
    en: "Production Line",
    zh: "生产线",
  },
  runOrder: {
    en: "Run Order",
    zh: "运行顺序",
  },
  messageRequired: {
    en: "Message is required",
    zh: "消息为必填项",
  },
  explainInterruptRunOrder: {
    en: "Explain why this run order needs to be interrupted...",
    zh: "请提供需要中断此运行的原因。",
  },
  explainResumeRunOrder: {
    en: "Explain why you are resuming this run order...",
    zh: "请提供恢复运行的原因。",
  },
  runOrderResumedSuccess: {
    en: "Run order resumed successfully",
    zh: "运行已成功恢复",
  },
  runOrderInterruptedSuccess: {
    en: "Run order interrupted successfully",
    zh: "运行已成功中断",
  },
  actionFailed: {
    en: "Action failed",
    zh: "操作失败",
  },
  resume: {
    en: "Resume",
    zh: "恢复",
  },
  interrupt: {
    en: "Interrupt",
    zh: "中断",
  },
  newRequest: {
    en: "New request",
    zh: "新要求",
  },
  message: {
    en: "Message",
    zh: "消息",
  },
  awaitingPurchasingApproval: {
    en: "Awaiting purchasing approval",
    zh: "等待确认",
  },
  awaitingForYourResponse: {
    en: "Awaiting for your response",
    zh: "等待工厂回复",
  },
  poOrderDate: {
    en: "PO Order Date",
    zh: "订单日期",
  },
  labelOrder: {
    en: "Label Ready",
    zh: "贴纸已订",
  },
  soakarPad: {
    en: "Soaker Pad",
    zh: "吸水垫",
  },
  directShipment: {
    en: "Direct Shipment",
    zh: "直接发货",
  },
  Run: {
    en: "Run Order",
    zh: "运行顺序",
  },
  planStartDay: {
    en: "Planned Start Date",
    zh: "预计生产日期",
  },
  actualStartDay: {
    en: "Act. Start Date",
    zh: "真实生产日期",
  },
  duration: {
    en: "Duration (Days)",
    zh: "持续时间（天）",
  },

  Duration: {
    en: "Duration (Days)",
    zh: "持续时间（天）",
  },

  actualCompletionDate: {
    en: "Act. Completion Date",
    zh: "实际完成日期",
  },
  expectedArrival: {
    en: "ETA (To Store)",
    zh: "预计到达",
  },
  estCompletion: {
    en: "Est. Completion Date",
    zh: "预计完成日期",
  },
  estPack: {
    en: "Est. Pack",
    zh: "预计装柜日期",
  },
  "delivery to": {
    en: "Delivery To",
    zh: "送货至",
  },
  etd: {
    en: "ETD",
    zh: "预计开船日",
  },
  eta: {
    en: "ETA",
    zh: "预计到达日",
  },
  shippingDeadline: {
    en: "Shipping Deadline",
    zh: "最迟起航日期",
  },
  search: {
    en: "Search",
    zh: "搜索",
  },
  searchProduct: {
    en: "Search Product",
    zh: "搜索产品",
  },
  productionStock: {
    en: "Production Stock",
    zh: "生产库存",
  },
  workOrderPlanning: {
    en: "Work Orders Planning",
    zh: "工单排程",
  },
  workOrders: {
    en: "work orders",
    zh: "工单",
  },
  workOrderStateProgress: {
    en: "In Progress",
    zh: "进行中",
  },
  workOrderStateReady: {
    en: "Ready",
    zh: "就绪",
  },
  workOrderStateWaiting: {
    en: "Waiting",
    zh: "等待中",
  },
  workOrderStatePending: {
    en: "Pending",
    zh: "待处理",
  },
  workOrderStateDone: {
    en: "Done",
    zh: "已完成",
  },
  workOrderStateCancel: {
    en: "Cancelled",
    zh: "已取消",
  },
  qldWorkOrderPlanning: {
    en: "QLD Work Order Planning",
    zh: "昆士兰工单计划",
  },
  integratedFromOdoo: {
    en: "Integrated from Odoo",
    zh: "与 Odoo 集成",
  },
  unassigned: {
    en: "Unassigned",
    zh: "未分配",
  },
  startDate: {
    en: "Start Date",
    zh: "开始日期",
  },
  endDate: {
    en: "End Date",
    zh: "结束日期",
  },
  startTime: {
    en: "Start Time",
    zh: "开始时间",
  },
  endTime: {
    en: "End Time",
    zh: "结束时间",
  },
  stopDate: {
    en: "Stop Date",
    zh: "结束日期",
  },
  workcenter: {
    en: "Workcenter",
    zh: "工作中心",
  },
  customerReference: {
    en: "Customer Reference(SAP SQ)",
    zh: "客户参考编号（SAP SQ）",
  },
  unknown: {
    en: "Unknown",
    zh: "未知",
  },
  operation: {
    en: "Operation",
    zh: "工序",
  },
  workCenter: {
    en: "Work Center",
    zh: "工作中心",
  },
  manufacturingOrder: {
    en: "Manufacturing Order",
    zh: "生产订单",
  },
  quantityRequired: {
    en: "Quantity Required",
    zh: "需求数量",
  },
  expectedDuration: {
    en: "Expected Duration",
    zh: "预计工时",
  },
  durationMinutes: {
    en: "Duration (minutes)",
    zh: "实际工时（分钟）",
  },
  ganttView: {
    en: "Gantt",
    zh: "甘特图",
  },
  listView: {
    en: "List",
    zh: "列表",
  },
  thisQuarter: {
    en: "This quarter",
    zh: "本季度",
  },
  thisYear: {
    en: "This year",
    zh: "本年度",
  },
  from: {
    en: "From",
    zh: "从",
  },
  apply: {
    en: "Apply",
    zh: "应用",
  },
  rawMaterialOverview: {
    en: "Raw Material Overview",
    zh: "原材料概览",
  },
  intouch: {
    en: "Intouch",
    zh: "Intouch",
  },
  intouchSchedule: {
    en: "Intouch Schedule",
    zh: "Intouch 排程",
  },
  finishedJobs: {
    en: "Finished Jobs",
    zh: "已完成作业",
  },
  expandAll: {
    en: "Expand All",
    zh: "全部展开",
  },
  collapseAll: {
    en: "Collapse All",
    zh: "全部收起",
  },
  lineMachine: {
    en: "Line / Machine",
    zh: "生产线 / 机器",
  },
  from: {
    en: "From",
    zh: "从",
  },
  importJobs: {
    en: "Import Jobs",
    zh: "导入作业",
  },
  importSummary: {
    en: "Import Summary",
    zh: "导入摘要",
  },
  imported: {
    en: "Imported",
    zh: "已导入",
  },
  warnings: {
    en: "Warnings",
    zh: "警告",
  },
  errors: {
    en: "Errors",
    zh: "错误",
  },
  importAllGood: {
    en: "All selected works orders were imported with no warnings or errors.",
    zh: "所选生产订单已全部导入，无警告或错误。",
  },
  confirmIntouchImport: {
    en: "Confirm Intouch Import",
    zh: "确认导入 Intouch",
  },
  confirmImport: {
    en: "Confirm Import",
    zh: "确认导入",
  },
  clearAll: {
    en: "Clear All",
    zh: "清除全部",
  },
  dateRange: {
    en: "Date Range",
    zh: "日期范围",
  },
  runReport: {
    en: "Run Report",
    zh: "运行报表",
  },
  changeFilters: {
    en: "Change Filters",
    zh: "更改筛选",
  },
  allMachinesHint: {
    en: "None selected — all lines/machines will be included",
    zh: "未选择 — 将包含所有生产线/机器",
  },
  rawMaterialStock: {
    en: "Raw Material Stock",
    zh: "原材料库存",
  },
  inventoryOverview: {
    en: "PMX Inventory",
    zh: "库存概览",
  },
  inventoryDetail: {
    en: "Inventory Detail",
    zh: "库存明细",
  },
  shipmentSearchPlaceholder: {
    en: "Enter Shipment Container Number",
    zh: "请输入货运集装箱编号",
  },

  shippingLine: {
    en: "Shipping Line",
    zh: "船公司",
  },
  newShippingDeadline: {
    en: "New Shipping Deadline",
    zh: "最遲起航日期（新）",
  },
  customer: {
    en: "Customer",
    zh: "客户名称",
  },
  item: {
    en: "Item",
    zh: "商品",
  },
  subject: {
    en: "Subject",
    zh: "主题",
  },
  priority: {
    en: "Priority",
    zh: "优先",
  },
  low: {
    en: "Low",
    zh: "低",
  },
  sealNo: {
    en: "Seal No",
    zh: "封条号",
  },
  selectPriority: {
    en: "Select Priority",
    zh: "选择优先",
  },
  orderIssue: {
    en: "High",
    zh: "订单问题",
  },
  productInquiry: {
    en: "Product Inquiry",
    zh: "产品查询",
  },
  other: {
    en: "Other",
    zh: "其他",
  },
  selectSubject: {
    en: "Select Subject",
    zh: "选择主题",
  },
  prodcutionline: {
    en: "Production Line",
    zh: "生产线",
  },
  incomingOrder: {
    en: "Incoming Shipments",
    zh: "收到订单",
  },

  transferOrder: {
    en: "Transfer Order",
    zh: "调令",
  },

  upcomingMonth: {
    en: "Upcoming Month",
    zh: "未来一个月",
  },
  nextMonth: {
    en: "Next Month",
    zh: "下个月",
  },
  threeMonths: {
    en: "3 Months",
    zh: "三个月",
  },
  sixMonths: {
    en: "6 Months",
    zh: "六个月",
  },
  requestDateAlerts: {
    en: "Alerts",
    zh: "请求日期警报",
  },
  ordersLabel: {
    en: "Orders",
    zh: "订单",
  },
  overdue: {
    en: "Overdue",
    zh: "已逾期",
  },
  next7Days: {
    en: "Next 7 Days",
    zh: "未来7天",
  },
  next14Days: {
    en: "Next 14 Days",
    zh: "未来14天",
  },
  next30Days: {
    en: "Next 30 Days",
    zh: "未来30天",
  },
  loadingOrders: {
    en: "Loading orders...",
    zh: "正在加载订单...",
  },
  loading: {
    en: "Loading...",
    zh: "加载中...",
  },
  noOrdersInTimeframe: {
    en: "No orders in the selected timeframe",
    zh: "所选时间范围内没有订单",
  },
  allCaughtUp: {
    en: "All caught up! Great job staying on schedule.",
    zh: "全部完成！非常棒，继续保持进度。",
  },
  itemLabel: {
    en: "Item",
    zh: "商品",
  },
  codeLabel: {
    en: "Code",
    zh: "代码",
  },
  quantityLabel: {
    en: "Quantity",
    zh: "数量",
  },
  statusLabel: {
    en: "Status",
    zh: "状态",
  },
  generatedStatus: {
    en: "Generated",
    zh: "已生成",
  },
  notGeneratedStatus: {
    en: "Not Generated",
    zh: "未生成",
  },
  today: {
    en: "Today",
    zh: "今天",
  },
  day: {
    en: "day",
    zh: "天",
  },
  days: {
    en: "days",
    zh: "天",
  },
  dayAgo: {
    en: "day ago",
    zh: "天前",
  },
  daysAgo: {
    en: "days ago",
    zh: "天前",
  },
  urgencyOverdue: {
    en: "OVERDUE",
    zh: "已逾期",
  },
  urgencyDueToday: {
    en: "DUE TODAY",
    zh: "今天到期",
  },
  urgencyDueTomorrow: {
    en: "DUE TOMORROW",
    zh: "明天到期",
  },
  urgencyUrgent: {
    en: "URGENT",
    zh: "紧急",
  },
  urgencySoon: {
    en: "SOON",
    zh: "即将",
  },
  urgencyUpcoming: {
    en: "UPCOMING",
    zh: "即将到来",
  },
  urgencyFuture: {
    en: "FUTURE",
    zh: "未来",
  },
  notAvailable: {
    en: "N/A",
    zh: "无",
  },
  checklist: {
    en: "Checklist",
    zh: "清单",
  },
  reviewRejectedOrders: {
    en: "Rejected Orders",
    zh: "审核被拒绝的订单",
  },
  allOrders: {
    en: "All Orders",
    zh: "所有订单",
  },
  pending: {
    en: "Pending",
    zh: "待办",
  },
  rejectedOrders: {
    en: "Rejected Orders",
    zh: "被拒绝的订单",
  },
  cancelledOrders: {
    en: "Cancelled Orders",
    zh: "取消订单",
  },
  archievedOrders: {
    en: "Archived Orders",
    zh: "已归档订单",
  },
  cancelled: {
    en: "Cancelled",
    zh: "取消",
  },
  dueDate: {
    en: "Due Date",
    zh: "到期日",
  },
  newDueDate: {
    en: "New Due Date",
    zh: "到期日（新）",
  },
  newOrderQty: {
    en: "New Order Qty",
    zh: "订单数量（新）",
  },
  flaggedOrderNumber: {
    en: "Flagged Order Number",
    zh: "标记的订单号",
  },
  vesselScheduling: {
    en: "Vessel Full Re-Scheduling",
    zh: "货船行程变更",
  },
  machineBroken: {
    en: "Machine Broken Down",
    zh: "机器故障",
  },
  selectasubejct: {
    en: "Select a subject",
    zh: "选择主题",
  },
  newduedate: {
    en: "New due date",
    zh: "新的到期日",
  },
  neworderqty: {
    en: "New order qty",
    zh: "新的订单数量",
  },

  newshippingdeadline: {
    en: "New shipping dealine",
    zh: "新的出货截止日期",
  },
  close: {
    en: "Close",
    zh: "关闭",
  },
  cancel: {
    en: "Cancel",
    zh: "取消",
  },
  resubmit: {
    en: "Resubmit",
    zh: "重新提交",
  },
  shipments: {
    en: "Shipments",
    zh: "装运",
  },

  addNew: {
    en: "Add New",
    zh: "新增",
  },
  run: {
    en: "Run",
    zh: "运行",
  },
  plannedQtyWarning: {
    en: "Planned quantity exceeds recommended max",
    zh: "计划数量超出建议最大值",
  },
  enterContainerNumber: {
    en: "Enter container number",
    zh: "输入集装箱号",
  },
  enterDurationDays: {
    en: "Enter duration days",
    zh: "输入持续天数",
  },
  enterRemarksOptional: {
    en: "Enter remarks (optional)",
    zh: "输入备注（可选）",
  },
  shipmentCreatedSuccess: {
    en: "Shipment created successfully",
    zh: "货件创建成功",
  },
  shipmentCreateFailed: {
    en: "Failed to create shipment:",
    zh: "创建货件失败：",
  },
  pleaseFillPlannedQty: {
    en: "Please fill in the Planned Quantity.",
    zh: "请填写计划数量。",
  },
  pleaseSelectProductionLine: {
    en: "Please select a Production Line.",
    zh: "请选择生产线。",
  },
  pleaseEnterDuration: {
    en: "Please enter a Duration.",
    zh: "请输入持续时间。",
  },
  containerNumberRequired: {
    en: "Container number is required",
    zh: "请填写集装箱号",
  },
  etdRequired: {
    en: "ETD is required",
    zh: "请填写预计出货日",
  },
  durationRequired: {
    en: "Duration is required",
    zh: "请填写持续时间",
  },
  pleaseSelectDate: {
    en: "Please select a date.",
    zh: "请选择日期。",
  },
  factoryOrderCreateSuccess: {
    en: "Factory order detail created successfully!",
    zh: "工厂订单明细创建成功！",
  },
  factoryOrderError: {
    en: "Error in factory order detail:",
    zh: "工厂订单明细出错：",
  },

  resolvedDate: {
    en: "Resolved Date",
    zh: "解决日期",
  },
  createdAt: {
    en: "Created Date",
    zh: "查询日期",
  },
  createdBy: {
    en: "User",
    zh: "用户",
  },
  history: {
    en: "History",
    zh: "历史",
  },

  flagged: {
    en: "Flagged",
    zh: "已标记",
  },
  interrupts: {
    en: "Interrupts",
    zh: "中断",
  },
  enquiries: {
    en: "Enquiries",
    zh: "查询",
  },

  askEnquiry: {
    en: "Ask Enquiry",
    zh: "询问",
  },

  createdByName: {
    en: "User",
    zh: "用户",
  },
  generatedBy: {
    en: "Generated By",
    zh: "用户",
  },
  approvedBy: {
    en: "Approved By",
    zh: "批准人",
  },
  updatePriority: {
    en: "Update Priority",
    zh: "更新优先级",
  },
  rejectOrderNumber: {
    en: "Reject Order Number",
    zh: "被拒订单",
  },

  reject: {
    en: "Reject",
    zh: "拒绝",
  },

  accept: {
    en: "Accept",
    zh: "接受",
  },

  enterQuantity: {
    en: "Enter Quantity",
    zh: "输入数量",
  },

  typeYourMessage: {
    en: "Type your message...",
    zh: "输入消息",
  },

  checkList: {
    en: "Checklist",
    zh: "订单清单",
  },

  itemsSelected: {
    en: "Item Selected",
    zh: "已选择商品",
  },

  revise: {
    en: "Revise",
    zh: "修订",
  },
  chinaordernumber: {
    en: "Order Number",
    zh: "订单编号",
  },

  createShipment: {
    en: "Create Shipment",
    zh: "创建货件",
  },

  shipmentNo: {
    en: "Shipment No",
    zh: "发货编号",
  },

  shipmentQty: {
    en: "Shipment Qty",
    zh: "出货数量",
  },

  containerNo: {
    en: "Container No",
    zh: "集装箱号",
  },

  ETA_ToStore: {
    en: "ETA To Store",
    zh: "预计到达时间",
  },

  remarks: {
    en: "Remarks",
    zh: "评论",
  },

  addNewRun: {
    en: "Add New Run",
    zh: "添加新生产",
  },

  addDirectShipment: {
    en: "Add Direct Shipment",
    zh: "添加直接送货",
  },

  interruptType: {
    en: "Interrupt Type",
    zh: "中断类型",
  },

  interruptedBy: {
    en: "Interrupted By",
    zh: "被打断",
  },

  generateShipment: {
    en: "Generate Shipment",
    zh: "生成发货",
  },

  incomingShipment: {
    en: "Incoming Shipment",
    zh: "进货",
  },

  chinaShipment: {
    en: "China Shipment",
    zh: "中国发货",
  },

  globalShipment: {
    en: "Global Shipment",
    zh: "全球发货",
  },

  chinaShipmentDetailsReport: {
    en: "China Shipment Details Report",
    zh: "中国出货详情报告",
  },

  globalShipmentDetailsReport: {
    en: "Global Shipment Details Report",
    zh: "全球发货详情报告",
  },

  vesselVoyage: {
    en: "Vessel / Voyage",
    zh: "船名 / 航次",
  },
  seaFreight: {
    en: "Sea Freight",
    zh: "海运费",
  },
  freightLine: {
    en: "Freight Line",
    zh: "货运线路",
  },
  itemDescription: {
    en: "Item Description",
    zh: "商品描述",
  },
  material: {
    en: "Material",
    zh: "材料",
  },
  label: {
    en: "Feature",
    zh: "特征",
  },
  spec: {
    en: "Spec",
    zh: "规格",
  },
  quantity: {
    en: "Quantity",
    zh: "数量",
  },
  grossWeight: {
    en: "Gross Weight",
    zh: "毛重",
  },
  netWeight: {
    en: "Net Weight",
    zh: "净重",
  },
  notes: {
    en: "Notes",
    zh: "备注",
  },
  noImage: {
    en: "No Image",
    zh: "无图片",
  },
  shipmentDetails: {
    en: "Shipment Details",
    zh: "出货详情",
  },
  items: {
    en: "Items",
    zh: "项目",
  },
  totalPcs: {
    en: "Total Pcs",
    zh: "总件数",
  },
  grossKg: {
    en: "Gross kg",
    zh: "毛重 kg",
  },
  containerInformation: {
    en: "Container Information",
    zh: "集装箱信息",
  },
  exportPdf: {
    en: "Export PDF",
    zh: "导出 PDF",
  },
  ctns: {
    en: "ctns",
    zh: "箱",
  },
  unitPcs: {
    en: "pcs",
    zh: "件",
  },
  unitKg: {
    en: "kg",
    zh: "公斤",
  },
  editShipment: {
    en: "Edit Shipment",
    zh: "编辑出货",
  },
  saveChanges: {
    en: "Save Changes",
    zh: "保存更改",
  },
  noShipmentItemsFound: {
    en: "No shipment items found.",
    zh: "未找到出货项目。",
  },
  dateFilter: {
    en: "Date Filter",
    zh: "日期筛选",
  },
  last6Months: {
    en: "Last 6 Months",
    zh: "最近6个月",
  },
  lastMonth: {
    en: "Last Month",
    zh: "上个月",
  },
  lastWeek: {
    en: "Last Week",
    zh: "上周",
  },
  showHideColumns: {
    en: "Show / Hide Columns",
    zh: "显示 / 隐藏列",
  },
  selectAll: {
    en: "Select All",
    zh: "全选",
  },
  resetOrder: {
    en: "Reset Order",
    zh: "重置顺序",
  },
  filter: {
    en: "Filter",
    zh: "筛选",
  },
  selected: {
    en: "selected",
    zh: "已选择",
  },
  display: {
    en: "Display",
    zh: "显示",
  },
  lastRefresh: {
    en: "Last Refresh",
    zh: "最后刷新",
  },
  carton: {
    en: "CARTON",
    zh: "箱",
  },
  cartons: {
    en: "CARTONS",
    zh: "箱",
  },
  piece: {
    en: "PIECE",
    zh: "件",
  },
  pieces: {
    en: "PIECES",
    zh: "件",
  },
  totalPerPallet: {
    en: "Total Per Pallet",
    zh: "每托盘总数",
  },
  perCartonLabel: {
    en: "Per CARTON",
    zh: "按箱",
  },
  perPieceLabel: {
    en: "Per PIECE",
    zh: "按件",
  },
  stock: {
    en: "Stock",
    zh: "库存",
  },
  stockReportDetails: {
    en: "Stock Report Details",
    zh: "库存报告详情",
  },
  product: {
    en: "Product",
    zh: "产品",
  },
  accountStatus: {
    en: "Account Status",
    zh: "账户状态",
  },
  customerCode: {
    en: "Customer Code",
    zh: "客户代码",
  },
  paymentGroup: {
    en: "Payment Group",
    zh: "付款组",
  },
  creditLine: {
    en: "Credit Line",
    zh: "信用额度",
  },
  variance: {
    en: "Variance",
    zh: "差异",
  },
  balance: {
    en: "Balance",
    zh: "余额",
  },
  openDeliveries: {
    en: "Open Deliveries",
    zh: "未结交货",
  },
  committedOrders: {
    en: "Committed Orders",
    zh: "已承诺订单",
  },
  sales: {
    en: "Sales",
    zh: "销售员",
  },
  customerStatus: {
    en: "Customer Status",
    zh: "客户状态",
  },
  customerOrder: {
    en: "Customer Order",
    zh: "客户订单",
  },
  poNumber: {
    en: "PO#",
    zh: "采购订单号",
  },
  msNumber: {
    en: "MS#",
    zh: "MS编号",
  },
  poDueDate: {
    en: "PO Due Date",
    zh: "采购订单到期日",
  },
  poWeekNo: {
    en: "PO Week#",
    zh: "采购订单周数",
  },
  poStatus: {
    en: "PO Status",
    zh: "采购订单状态",
  },
  etdDate: {
    en: "ETD",
    zh: "ETD",
  },
  etaPort: {
    en: "ETA Port",
    zh: "ETA Port",
  },
  etaStore: {
    en: "ETA Store",
    zh: "ETA Store",
  },
  deliveredDate: {
    en: "Delivered Date",
    zh: "交付日期",
  },
  shippedQty: {
    en: "Shipped Qty",
    zh: "发货数量",
  },
  shippedQtyCtn: {
    en: "Shipped Qty (Ctn)",
    zh: "发货数量(箱)",
  },
  qtyToShip2: {
    en: "Qty to Ship2",
    zh: "待发货数量2",
  },
  qtyToShipCtn: {
    en: "Qty to Ship (Ctn)",
    zh: "待发货数量(箱)",
  },
  followUp: {
    en: "Follow up",
    zh: "跟进",
  },
  itmsGrpNam: {
    en: "ItmsGrpNam",
    zh: "项目组名称",
  },
  labelType: {
    en: "Label Type",
    zh: "标签类型",
  },

  packQty: {
    en: "Pack Qty",
    zh: "包装数量",
  },
  orderedQty: {
    en: "Ordered Qty",
    zh: "订购数量",
  },
  orderedQtyCtn: {
    en: "Ordered Qty (Ctn)",
    zh: "订购数量(箱)",
  },
  totalShippedQty: {
    en: "Total Shipped Qty",
    zh: "总发货数量",
  },
  totalShippedQtyCtn: {
    en: "Total Shipped Qty (Ctn)",
    zh: "总发货数量(箱)",
  },
  shipToAddress: {
    en: "Ship To Address",
    zh: "送货地址",
  },
  poRemarks: {
    en: "PO Remarks",
    zh: "采购订单备注",
  },
  soDueDate: {
    en: "SO Due Date",
    zh: "销售订单到期日",
  },
  operationRemarks: {
    en: "Operation Remarks",
    zh: "操作备注",
  },
  deliveryReport: {
    en: "Delivery Report",
    zh: "交货报告",
  },
  warehouse: {
    en: "Warehouse",
    zh: "仓库",
  },
  document: {
    en: "Document",
    zh: "文件",
  },
  shippingType: {
    en: "Shipping Type",
    zh: "运输类型",
  },
  shippingCode: {
    en: "Shipping Code",
    zh: "运输代码",
  },
  payment: {
    en: "Payment",
    zh: "付款",
  },
  operator: {
    en: "Operator",
    zh: "操作员",
  },
  uom1: {
    en: "Uom1",
    zh: "计量单位1",
  },
  uom2: {
    en: "Uom2",
    zh: "计量单位2",
  },
  batchNumber: {
    en: "Batch number",
    zh: "批号",
  },
  ssccNumber: {
    en: "SSCC number",
    zh: "SSCC编号",
  },
  status: {
    en: "Status",
    zh: "状态",
  },
  aisle: {
    en: "Aisle",
    zh: "通道",
  },
  pmxInventory: {
    en: "PMX Inventory",
    zh: "PMX库存",
  },
  box: {
    en: "Box",
    zh: "箱",
  },
  productionStocks: {
    en: "Production Stocks",
    zh: "生产库存",
  },
  productCode: {
    en: "Product Code",
    zh: "产品代码",
  },
  committed: {
    en: "Committed",
    zh: "已承诺",
  },
  required: {
    en: "Required",
    zh: "所需",
  },
  ordered: {
    en: "Ordered",
    zh: "已订购",
  },
  rawMaterialGroup: {
    en: "Raw Material Group",
    zh: "原材料组",
  },
  rawMaterial: {
    en: "Raw Material",
    zh: "原材料",
  },
  rawMaterials: {
    en: "Raw Materials",
    zh: "原材料",
  },

  aPET: {
    en: "APET",
    zh: "APET",
  },
  rPET50: {
    en: "RPET50",
    zh: "RPET50",
  },
  rPET80: {
    en: "RPET80",
    zh: "RPET80",
  },
  rPET100: {
    en: "RPET100",
    zh: "RPET100",
  },
  available: {
    en: "Available",
    zh: "可用",
  },
  onWater: {
    en: "On Water",
    zh: "在途",
  },
  onOrder: {
    en: "On Order",
    zh: "已订购",
  },
  pcsCarton: {
    en: "Pcs\n(Carton)",
    zh: "件 (箱)",
  },
  ctnsPerPallet: {
    en: "Ctns\n(Pallet)",
    zh: "箱 (托盘)",
  },
  availablePallet: {
    en: "Available\n(Pallet)",
    zh: "可用 (托盘)",
  },
  inTransit: {
    en: "In Transit\n(Sea)",
    zh: "在途 (海)",
  },
  onHand: {
    en: "On Hand",
    zh: "库存",
  },
  reserved: {
    en: "Reserved",
    zh: "已预留",
  },

  lastUpdate: {
    en: "Last Update",
    zh: "最后更新",
  },
  recentShipments: {
    en: "Recent Shipments",
    zh: "近期出货",
  },
  thisWeek: {
    en: "This Week",
    zh: "本周",
  },
  thisMonth: {
    en: "This Month",
    zh: "本月",
  },

  recent: {
    en: "Recent",
    zh: "最近",
  },
  oldest: {
    en: "Oldest",
    zh: "最早",
  },
  of: {
    en: "of",
    zh: "共",
  },
  orderReceived: {
    en: "Order Received",
    zh: "订单已收到",
  },
  shipmentCompleted: {
    en: "Shipment Completed",
    zh: "发货完成",
  },
  orderCompleted: {
    en: "Order Completed",
    zh: "订单完成",
  },
  totalShipped: {
    en: "Total Shipped",
    zh: "总发货量",
  },
  remainingToShip: {
    en: "Remaining To Ship",
    zh: "剩余发货量",
  },
  shippingContainer: {
    en: "Shipping Container",
    zh: "集装箱号",
  },
  leadTime: {
    en: "Lead Time",
    zh: "交货期",
  },
  trackingHistory: {
    en: "Tracking History",
    zh: "追踪历史",
  },
  orderQtyUom: {
    en: "Order Qty (UoM)",
    zh: "订单数量 (单位)",
  },
  dashboard: {
    en: "Dashboard",
    zh: "仪表板",
  },
  usage: {
    en: "Usage",
    zh: "使用情况",
  },
  value: {
    en: "Value",
    zh: "价值",
  },
  invoicedn: {
    en: "Invoice & DN",
    zh: "发票与交货单",
  },
  validUntil: {
    en: "Valid until",
    zh: "有效期至",
  },
  docStatus: {
    en: "Doc Status",
    zh: "单据状态",
  },
  salesScorecardTitle: {
    en: "Sales Scorecard - Year On Year Usage",
    zh: "销售记分卡 - 逐年使用量",
  },
  usageSalesScorecardTitle: {
    en: "Usage Sales Scorecard — Monthly Usage",
    zh: "使用量销售记分卡 — 月度使用量",
  },
  valueSalesScorecardTitle: {
    en: "Value Sales Scorecard — Monthly Value",
    zh: "价值销售记分卡 — 月度价值",
  },
  yoyUsage: {
    en: "Year On Year Usage",
    zh: "逐年用量对比",
  },
  usageByItemGroup: {
    en: "Usage by Item Group",
    zh: "按产品类别用量",
  },
  usageByCustomer: {
    en: "Usage by Customer",
    zh: "按客户用量",
  },
  monthlyUsage: {
    en: "Monthly Usage",
    zh: "月度用量",
  },
  yoyPct: {
    en: "YoY %",
    zh: "同比(%)",
  },
  quantities: {
    en: "QUANTITIES",
    zh: "数量",
  },
  availability: {
    en: "AVAILABILITY",
    zh: "可用性",
  },
  otherInformation: {
    en: "OTHER INFORMATION",
    zh: "其他信息",
  },
  Organizations: {
    en: "Organizations",
    zh: "组织",
  },
  "Organizational Users": {
    en: "Organizational Users",
    zh: "组织用户",
  },
  uploadShipmentFile: {
    en: "Upload Shipment File",
    zh: "上传装柜文件",
  },
  clickToSelectXlsx: {
    en: "Click to select .xlsx file",
    zh: "点击选择 .xlsx 文件",
  },
  convertBtn: {
    en: "Convert",
    zh: "转换",
  },
  processingFile: {
    en: "Converting packing lists…",
    zh: "转换装柜清单中…",
  },
  filesSelectedLabel: {
    en: "files selected",
    zh: "个文件已选择",
  },
  maxFilesHint: {
    en: "You can select up to",
    zh: "最多可选择",
  },
  tooManyFilesError: {
    en: "Too many files. Please select at most",
    zh: "文件过多。最多请选择",
  },
  allFilesFailedError: {
    en: "None of the selected files could be converted.",
    zh: "所选文件均无法转换。",
  },
  duplicateContainerInBatchError: {
    en: "Two packing lists share the same container no:",
    zh: "两份装柜清单的柜号相同：",
  },
  containerProgressLabel: {
    en: "Container",
    zh: "柜号",
  },
  reviewShipmentData: {
    en: "Review Shipment Data",
    zh: "查看装柜数据",
  },
  containerDetails: {
    en: "Container Details",
    zh: "柜号详情",
  },
  itemsLabel: {
    en: "Items",
    zh: "品项",
  },
  totalBoxesLabel: {
    en: "Total Boxes",
    zh: "总箱数",
  },
  totalGrossKgLabel: {
    en: "Total Gross (kg)",
    zh: "总毛重 (kg)",
  },
  totalNetKgLabel: {
    en: "Total Net (kg)",
    zh: "总净重 (kg)",
  },
  stockQtyStatLabel: {
    en: "Stock (走库存)",
    zh: "走库存",
  },
  cnItemNameLabel: {
    en: "CN Item Name",
    zh: "商品名称",
  },
  cnItemCodeLabel: {
    en: "CN Item Code",
    zh: "商品代码",
  },
  itemTypeLabel: {
    en: "Item Type",
    zh: "品项类型",
  },
  pcsPerBoxLabel: {
    en: "Pcs / Box",
    zh: "每箱数量",
  },
  boxesLabel: {
    en: "Boxes",
    zh: "箱数",
  },
  totalQtyLabel: {
    en: "Total Qty",
    zh: "总数量",
  },
  grossPerBoxLabel: {
    en: "Gross / Box (kg)",
    zh: "每箱毛重 (kg)",
  },
  netPerBoxLabel: {
    en: "Net / Box (kg)",
    zh: "每箱净重 (kg)",
  },
  palletWtLabel: {
    en: "Pallet Wt (kg)",
    zh: "卡板重量 (kg)",
  },
  paperCoreWtLabel: {
    en: "Paper Core Wt (kg)",
    zh: "纸芯筒重量 (kg)",
  },
  actualGrossKgLabel: {
    en: "Actual Gross (kg)",
    zh: "实际毛重 (kg)",
  },
  outerCartonMarkLabel: {
    en: "Outer Carton Mark",
    zh: "外箱标",
  },
  remarksLabel: {
    en: "Remarks",
    zh: "备注",
  },
  backBtn: {
    en: "Back",
    zh: "返回",
  },
  nextBtn: {
    en: "Next",
    zh: "下一步",
  },
  containerNoRequiredForMatch: {
    en: "Container No is required to match orders.",
    zh: "需要柜号才能匹配订单。",
  },
  selectFileFirstError: {
    en: "Please select an .xlsx file first.",
    zh: "请先选择一个 .xlsx 文件。",
  },
  uploadToS3FailedError: {
    en: "Failed to upload file to S3.",
    zh: "上传文件到S3失败。",
  },
  failedToProcessFileError: {
    en: "Failed to process file.",
    zh: "处理文件失败。",
  },
  containerType: {
    en: "Container Type",
    zh: "柜型",
  },
  departureDate: {
    en: "Departure Date",
    zh: "起航日期",
  },
  arrivalDate: {
    en: "Arrival Date",
    zh: "到港日期",
  },
  destination: {
    en: "Destination",
    zh: "到达地点",
  },
  forwarder: {
    en: "Forwarder",
    zh: "货代",
  },
  freight: {
    en: "Freight",
    zh: "海运费",
  },
  freeDays: {
    en: "Free Days",
    zh: "免柜租天数",
  },
  vgmKg: {
    en: "VGM (kg)",
    zh: "VGM (kg)",
  },
  responsiblePerson: {
    en: "Responsible Person",
    zh: "负责人",
  },
  reportDate: {
    en: "Report Date",
    zh: "填表日期",
  },
  containerNoExcel: {
    en: "Container No",
    zh: "柜号",
  },
  sealNoExcel: {
    en: "Seal No",
    zh: "封条",
  },
  vesselVoyageExcel: {
    en: "Vessel / Voyage",
    zh: "航次",
  },
  materialExcel: {
    en: "Material",
    zh: "物料",
  },
  specExcel: {
    en: "Spec",
    zh: "胶片规格",
  },
  featureExcel: {
    en: "Feature",
    zh: "盒身工艺和配件",
  },
  matchMsNoTitle: {
    en: "Match MS No",
    zh: "匹配MS订单号",
  },
  noMsRefLabel: {
    en: "No MS No",
    zh: "无MS订单号",
  },
  containerLookupFailedError: {
    en: "Container not found. Please try again.",
    zh: "找不到该柜号，请重试。",
  },
  noMatchLabel: {
    en: "No Match",
    zh: "无匹配",
  },
  searchBtn: {
    en: "Search",
    zh: "搜索",
  },
  createShipmentBtn: {
    en: "Create Shipment",
    zh: "创建发货",
  },
  noItemsMatchedError: {
    en: "Please match at least one item before creating the shipment.",
    zh: "请至少匹配一个品项后再创建发货。",
  },
  unresolvedOrderLinesError: {
    en: "Container {container}: {items} matched only order lines that China Order Tracker does not list — closed, cancelled, or not yet approved. Search another MS No, or have the order approved first.",
    zh: "货柜 {container}：{items} 只匹配到中国订单跟踪未列出的订单行 — 已关闭、已取消，或尚未审批。请搜索其他 MS No，或先完成订单审批。",
  },
  msNoHasNoRunToast: {
    en: "{count} item(s) have no run in China Order Tracker.",
    zh: "{count} 个品项在中国订单跟踪中没有生产批次。",
  },
  msNoHasNoRunWarning: {
    en: "{items} — no run exists for this item under this MS No in China Order Tracker, so its quantity cannot be counted against one. Any run listed above belongs to a different product; if this item's run does exist, pick it from the list instead. Creating anyway stores the line with no order link: it keeps its weight in the container and shows in China Shipment details, but no run is updated. Ask the planner to create the run if one was expected.",
    zh: "{items} — 此品项在该 MS No 下于中国订单跟踪中没有生产批次，数量无法计入任何批次。上方列出的批次属于其他产品；若此品项确有批次，请从列表中选择。若仍然创建，该行将以未关联订单的方式保存：重量仍计入货柜并显示在中国发货明细中，但不会更新任何批次。若本应存在批次，请联系计划人员创建。",
  },
  createAnywayBtn: {
    en: "Create anyway",
    zh: "仍然创建",
  },
  noRunForItemLabel: {
    en: "No run found for this item under this MS No",
    zh: "此 MS No 下未找到此品项的生产批次",
  },
  removeShipmentWarningTitle: {
    en: "Remove this shipment?",
    zh: "确定移除这个装运？",
  },
  removeShipmentWarningMessage: {
    en: "The shipment and its lines will be deleted, and the quantities they added to each run on China Order Tracker will be removed with them. This cannot be undone.",
    zh: "此装运及其明细将被删除，并同时移除它在 China Order Tracker 各批次上所计的数量。此操作无法复原。",
  },
  removeShipmentBtn: {
    en: "Remove shipment",
    zh: "移除装运",
  },
  shipmentRemovedSuccess: {
    en: "Shipment {container} removed",
    zh: "已移除装运 {container}",
  },
  shipmentRemoveFailedError: {
    en: "Could not remove the shipment. Nothing was changed.",
    zh: "无法移除此装运，未作任何更改。",
  },
  expandAllBtn: {
    en: "Expand all",
    zh: "全部展开",
  },
  collapseAllBtn: {
    en: "Collapse all",
    zh: "全部收起",
  },
  auLabelLabel: {
    en: "AU Label",
    zh: "澳洲标签",
  },
  artworkNoLabel: {
    en: "Artwork No",
    zh: "图稿编号",
  },
  cartonLabelLabel: {
    en: "Factory carton label — tap to enlarge",
    zh: "工厂外箱标 — 点击放大",
  },
  differentProductPickedLabel: {
    en: "Selected run is a different product — double-check before creating",
    zh: "所选批次属于其他产品 — 创建前请再次确认",
  },
  skuSameFamilyLabel: {
    en: "Same family, different item — CN {cn} vs AU {au}",
    zh: "同系列但不同品项 — CN {cn} / AU {au}",
  },
  skuAmbiguousLabel: {
    en: "Several runs share this item code — pick the right one",
    zh: "多个批次使用相同品项代码 — 请选择正确的一个",
  },
  unpickedOrderLineError: {
    en: "Container {container}: select an order line for {items}, or search another MS No.",
    zh: "货柜 {container}：请为 {items} 选择订单行，或搜索其他 MS No。",
  },
  shipmentCreateFailedError: {
    en: "Failed to create shipment.",
    zh: "创建发货失败。",
  },
  shipmentCreatedSuccess: {
    en: "Shipment created successfully.",
    zh: "发货创建成功。",
  },
  shippedQtyLabel: {
    en: "Shipped / Planned",
    zh: "已发货/计划数量",
  },
  sapRequestDateLabel: {
    en: "SAP Request Date",
    zh: "SAP要求日期",
  },
  replaceShipmentWarningTitle: {
    en: "Replace Existing Shipment?",
    zh: "替换现有出货？",
  },
  replaceShipmentWarningMessage: {
    en: "A shipment for this container already exists. Replacing it will overwrite the existing container and item details.",
    zh: "该柜号已存在出货记录。替换后将覆盖现有的柜子和商品明细。",
  },
  continueBtn: {
    en: "Continue",
    zh: "继续",
  },
  updateShipmentBtn: {
    en: "Update Shipment",
    zh: "更新出货",
  },
  matchedToExistingLabel: {
    en: "Matched to existing item",
    zh: "已匹配现有商品",
  },
  otherRunsAvailableLabel: {
    en: "This line item has more than one Run — select the correct one below if needed",
    zh: "该品项有多个批次(Run)，如需请在下方选择正确的批次",
  },
  itemsToBeRemovedLabel: {
    en: "The following items will be removed from this shipment",
    zh: "以下品项将从此出货中移除",
  },
  oldValueLabel: {
    en: "Old",
    zh: "旧",
  },
  newValueLabel: {
    en: "New",
    zh: "新",
  },
  noChangesLabel: {
    en: "No changes",
    zh: "无变更",
  },
  shipmentUpdatedSuccess: {
    en: "Shipment updated successfully.",
    zh: "出货更新成功。",
  },
  shipmentUpdateFailedError: {
    en: "Failed to update shipment.",
    zh: "更新出货失败。",
  },
  orderSplitLabel: {
    en: "Order",
    zh: "订单",
  },
  stockSplitLabel: {
    en: "Stock (走库存)",
    zh: "走库存",
  },
  filmLogAttachedSuccess: {
    en: "Film roll detail attached to the shipment",
    zh: "胶片明细已附加至装柜清单",
  },
  filmLogNoShipmentError: {
    en: "No shipment exists for container {container} — upload its 装柜清单 first",
    zh: "柜号 {container} 尚无装柜清单，请先上传装柜清单",
  },
  filmLogNoContainerError: {
    en: "Could not read a container number from {file} — rename it to include the container, e.g. CMAU7839613",
    zh: "无法从 {file} 中识别柜号，请在文件名中包含柜号，例如 CMAU7839613",
  },
  attachmentOpenFailedError: {
    en: "Could not open {file}",
    zh: "无法打开 {file}",
  },
  filmLogAttachFailedError: {
    en: "Could not attach {file} to its shipment",
    zh: "无法将 {file} 附加至对应装柜清单",
  },
  filmLogAttachmentLabel: {
    en: "Film roll detail",
    zh: "胶片明细",
  },
  subtotalsHeading: {
    en: "Subtotals by category (合计)",
    zh: "分类合计",
  },
  subtotalGrossShort: {
    en: "gross",
    zh: "毛重",
  },
  subtotalNetShort: {
    en: "net",
    zh: "净重",
  },
  noOrderLinkRequiredLabel: {
    en: "No order link required",
    zh: "无需关联订单",
  },
  verbalOrderLabel: {
    en: "Verbal order (口头单)",
    zh: "口头单",
  },
  noOrderLinkExplainer: {
    en: "No 澳洲订单号 on this line — it will be saved to the shipment without linking to China Order Tracker",
    zh: "该行无澳洲订单号，将直接保存至装柜清单，不关联中国订单跟踪",
  },
  noDirectShipmentLabel: {
    en: "No Direct Shipment found for this order — nothing to add for stock qty",
    zh: "未找到该订单的直接发货，库存数量无法添加",
  },
  createDirectShipmentCheckbox: {
    en: "Create Direct Shipment for",
    zh: "为以下品项创建直接发货：",
  },
  directShipmentTickedHint: {
    en: "On submit, a new Direct Shipment will be created on China Order Tracker. Clear the tick to skip it.",
    zh: "提交后，将在中国订单跟踪中创建一个新的直接发货。取消勾选则不创建。",
  },
  directShipmentClearedHint: {
    en: "No Direct Shipment will be created — this stock qty stays unmatched and will not be shipped.",
    zh: "将不会创建直接发货 — 此库存数量仍未匹配，不会发货。",
  },
  createDirectShipmentFailedError: {
    en: "Failed to create Direct Shipment.",
    zh: "创建直接发货失败。",
  },
  salesSampleRequest: {
    en: "Sales - Sample Request",
    zh: "销售 - 样品申请",
  },
  sampleRequestCreatedDate: {
    en: "Created Date",
    zh: "创建日期",
  },
  pendingApproval: {
    en: "Pending Approval",
    zh: "待审批",
  },
  changesRequested: {
    en: "Changes Requested",
    zh: "需修改",
  },
  sentToFactory: {
    en: "Sent to Factory",
    zh: "已发送至工厂",
  },
  reviewingCad: {
    en: "Reviewing CAD",
    zh: "CAD 审核中",
  },
  cadChangesRequested: {
    en: "CAD Changes Requested",
    zh: "CAD 需修改",
  },
  inProduction: {
    en: "In Production",
    zh: "生产中",
  },
  sampleStatusCompleted: {
    en: "Completed",
    zh: "已完成",
  },
  declined: {
    en: "Declined",
    zh: "已拒绝",
  },
  addRequest: {
    en: "Add Request",
    zh: "新增申请",
  },
  noSampleRequestsFound: {
    en: "No sample requests found",
    zh: "未找到样品申请",
  },
  sampleRequestSubmitted: {
    en: "Sample request submitted",
    zh: "样品申请已提交",
  },
  failedToSubmitSampleRequest: {
    en: "Failed to submit sample request",
    zh: "样品申请提交失败",
  },
  editRequest: {
    en: "Edit Request",
    zh: "编辑申请",
  },
  addRequestSubtitle: {
    en: "Fill in the fields below, or upload a completed sample request form.",
    zh: "请填写以下字段，或上传已填写的样品申请表。",
  },
  editRequestSubtitle: {
    en: "Update the sample or delivery details for",
    zh: "更新以下申请的样品或送货信息：",
  },
  sampleInfoSection: {
    en: "1. Sample Info",
    zh: "1. 样品信息",
  },
  deliveryInfoSection: {
    en: "2. Delivery Info",
    zh: "2. 送货信息",
  },
  sampleQtyNeeded: {
    en: "Sample Qty Needed",
    zh: "所需样品数量",
  },
  descriptionOfSamples: {
    en: "Description of Samples/Remarks",
    zh: "样品描述/备注",
  },
  purposeOfSampleRequest: {
    en: "Purpose of Sample Request",
    zh: "样品申请目的",
  },
  selectPurpose: {
    en: "Select purpose",
    zh: "选择目的",
  },
  specifyPurpose: {
    en: "Specify the purpose",
    zh: "请说明目的",
  },
  imageDrawing: {
    en: "Image/ Drawing",
    zh: "图片/图纸",
  },
  uploadDrawingOrSpec: {
    en: "Upload a drawing or spec sheet",
    zh: "上传图纸或规格表",
  },
  uploadRevisedDrawingOrSpec: {
    en: "Upload a revised drawing or spec sheet",
    zh: "上传修改后的图纸或规格表",
  },
  deliveryContactPerson: {
    en: "Delivery Contact Person",
    zh: "收货联系人",
  },
  deliveryContactNo: {
    en: "Delivery Contact No.",
    zh: "收货联系电话",
  },
  submittingEllipsis: {
    en: "Submitting...",
    zh: "提交中...",
  },
  savingEllipsis: {
    en: "Saving...",
    zh: "保存中...",
  },
  uploadingEllipsis: {
    en: "Uploading…",
    zh: "上传中…",
  },
  sampleCustomerPlaceholder: {
    en: "e.g. Costa",
    zh: "例如：Costa",
  },
  sampleItemPlaceholder: {
    en: "e.g. CJ-025(60)",
    zh: "例如：CJ-025(60)",
  },
  customerRequired: {
    en: "Customer is required.",
    zh: "请填写客户。",
  },
  itemNameRequired: {
    en: "Item name is required.",
    zh: "请填写商品名称。",
  },
  sampleQtyRequired: {
    en: "Sample qty needed is required.",
    zh: "请填写所需样品数量。",
  },
  wholeNumberMin1: {
    en: "Enter a whole number of 1 or more.",
    zh: "请输入大于或等于 1 的整数。",
  },
  selectAPurpose: {
    en: "Select a purpose.",
    zh: "请选择目的。",
  },
  specifyPurposeRequired: {
    en: "Please specify the purpose.",
    zh: "请说明目的。",
  },
  useDateFormatDDMMYYYY: {
    en: "Use DD/MM/YYYY format.",
    zh: "请使用 DD/MM/YYYY 格式。",
  },
  deliveryContactPersonRequired: {
    en: "Delivery contact person is required.",
    zh: "请填写收货联系人。",
  },
  deliveryContactNumberRequired: {
    en: "Delivery contact number is required.",
    zh: "请填写收货联系电话。",
  },
  deliveryAddressRequired: {
    en: "Delivery address is required.",
    zh: "请填写送货地址。",
  },
  fileUploadNativeUnsupported: {
    en: "File upload isn't wired up for native yet",
    zh: "移动端暂不支持文件上传",
  },
  couldNotRead: {
    en: "Could not read",
    zh: "无法读取",
  },
  fixHighlightedFields: {
    en: "Please fix the highlighted fields",
    zh: "请修正标红的字段",
  },
  failedUploadRequestNotSubmitted: {
    en: "Failed to upload attachments — request not submitted",
    zh: "附件上传失败 — 申请未提交",
  },
  failedUploadChangesNotSaved: {
    en: "Failed to upload attachments — changes not saved",
    zh: "附件上传失败 — 更改未保存",
  },
  purposeNewCustomer: {
    en: "New Customer",
    zh: "新客户",
  },
  purposeCustomerTrials: {
    en: "Customer trials or testing",
    zh: "客户试用或测试",
  },
  purposeWarehouseUsage: {
    en: "Multisteps warehouse usage (samples out of stock)",
    zh: "Multisteps 仓库使用（样品缺货）",
  },
  purposeNewSampleCustomer: {
    en: "New Sample Customer",
    zh: "新样品客户",
  },
  purposeDepthMaterialChange: {
    en: "Depth or material change",
    zh: "深度或材料变更",
  },
  purposeColourMatching: {
    en: "Colour matching",
    zh: "配色",
  },
  purposeWallThicknessChange: {
    en: "Wall thickness change",
    zh: "壁厚变更",
  },
  sampleStatusClosed: {
    en: "Closed",
    zh: "已关闭",
  },
  alertPendingApproval: {
    en: "Awaiting management to review and approve the sample request",
    zh: "等待管理层审核并批准样品申请",
  },
  alertChangesRequested: {
    en: "Awaiting sales to make requested changes",
    zh: "等待销售按要求进行修改",
  },
  alertSentToFactory: {
    en: "Awaiting China to update the CAD drawing, tooling cost and remarks",
    zh: "等待中国团队更新 CAD 图纸、工装成本及备注",
  },
  alertReviewingCad: {
    en: "Awaiting Management to approve the CAD drawing and tooling cost",
    zh: "等待管理层批准 CAD 图纸及工装成本",
  },
  alertCadChangesRequested: {
    en: "Awaiting China to make requested CAD changes",
    zh: "等待中国团队按要求修改 CAD",
  },
  alertInProduction: {
    en: "Awaiting China to start production on the sample",
    zh: "等待中国团队开始样品生产",
  },
  alertShipped: {
    en: "Awaiting Sales to confirm samples has been received",
    zh: "等待销售确认已收到样品",
  },
  view: {
    en: "View",
    zh: "查看",
  },
  approve: {
    en: "Approve",
    zh: "批准",
  },
  requestChanges: {
    en: "Request Changes",
    zh: "要求修改",
  },
  sendToSales: {
    en: "Send to Sales",
    zh: "发送给销售",
  },
  sendToChina: {
    en: "Send to China",
    zh: "发送给中国团队",
  },
  submitChanges: {
    en: "Submit Changes",
    zh: "提交修改",
  },
  submitForApproval: {
    en: "Submit for Approval",
    zh: "提交审批",
  },
  resubmitForApproval: {
    en: "Resubmit for Approval",
    zh: "重新提交审批",
  },
  reasonForDeclining: {
    en: "Reason for declining this request",
    zh: "拒绝此申请的原因",
  },
  whatNeedsToChange: {
    en: "What needs to change?",
    zh: "需要修改哪些内容？",
  },
  toolingCostOptional: {
    en: "Tooling Cost (optional)",
    zh: "工装成本（可选）",
  },
  remarksOptional: {
    en: "Remarks (optional)",
    zh: "备注（可选）",
  },
  samplesOptional: {
    en: "Samples (optional)",
    zh: "样品（可选）",
  },
  toolingCostPlaceholder: {
    en: "e.g. RMB 40,000",
    zh: "例如：RMB 40,000",
  },
  notesForManagement: {
    en: "Any notes for Management",
    zh: "给管理层的备注",
  },
  trackingNumberRequiredLabel: {
    en: "Tracking Number *",
    zh: "运单号 *",
  },
  trackingLinkOptional: {
    en: "Tracking Link (optional)",
    zh: "跟踪链接（可选）",
  },
  trackingLinkPlaceholder: {
    en: "DHL / FedEx tracking URL",
    zh: "DHL / FedEx 跟踪链接",
  },
  courierOptional: {
    en: "Courier (optional)",
    zh: "快递公司（可选）",
  },
  courierPlaceholder: {
    en: "e.g. DHL",
    zh: "例如：DHL",
  },
  shippedDateOptional: {
    en: "Shipped Date (optional)",
    zh: "发货日期（可选）",
  },
  shippedDatePlaceholder: {
    en: "DD/MM/YYYY — defaults to today",
    zh: "DD/MM/YYYY — 默认为今天",
  },
  evidenceOfShipmentRequiredLabel: {
    en: "Evidence of Shipment *",
    zh: "发货凭证 *",
  },
  uploadEvidenceOfShipment: {
    en: "Upload evidence of shipment",
    zh: "上传发货凭证",
  },
  markAsShipped: {
    en: "Mark as Shipped",
    zh: "标记为已发货",
  },
  sampleReceived: {
    en: "Sample Received",
    zh: "已收到样品",
  },
  alert: {
    en: "Alert",
    zh: "提醒",
  },
  summaryInfo: {
    en: "Summary Info",
    zh: "概要信息",
  },
  deliveryInfo: {
    en: "Delivery Info",
    zh: "送货信息",
  },
  dateRaised: {
    en: "Date Raised",
    zh: "提交日期",
  },
  deliveryContact: {
    en: "Delivery Contact",
    zh: "收货联系人",
  },
  remarksOfSamples: {
    en: "Remarks of Samples",
    zh: "样品备注",
  },
  mouldPreparation: {
    en: "Mould Preparation",
    zh: "模具准备",
  },
  drawingProvidedByFactory: {
    en: "Drawing Provided by Factory",
    zh: "工厂是否提供图纸",
  },
  toolingRequestBy: {
    en: "Tooling Request by",
    zh: "工装申请人",
  },
  toolingApprovedBy: {
    en: "Tooling Approved by",
    zh: "工装批准人",
  },
  trackingInfo: {
    en: "Tracking Info",
    zh: "物流信息",
  },
  courier: {
    en: "Courier",
    zh: "快递公司",
  },
  trackingNumber: {
    en: "Tracking Number",
    zh: "运单号",
  },
  trackingLink: {
    en: "Tracking Link",
    zh: "跟踪链接",
  },
  trackShipment: {
    en: "Track shipment",
    zh: "跟踪物流",
  },
  shippedDate: {
    en: "Shipped Date",
    zh: "发货日期",
  },
  evidenceOfShipment: {
    en: "Evidence of Shipment",
    zh: "发货凭证",
  },
  activities: {
    en: "Activities",
    zh: "动态",
  },
  noActivityYet: {
    en: "No activity yet",
    zh: "暂无动态",
  },
  yes: {
    en: "Yes",
    zh: "是",
  },
  no: {
    en: "No",
    zh: "否",
  },
  roleSales: {
    en: "Sales",
    zh: "销售",
  },
  roleManagement: {
    en: "Management",
    zh: "管理层",
  },
  roleChina: {
    en: "China",
    zh: "中国团队",
  },
  roleProduction: {
    en: "Production",
    zh: "生产",
  },
  roleSystem: {
    en: "System",
    zh: "系统",
  },
  sampleRequestApproved: {
    en: "Sample request approved",
    zh: "样品申请已批准",
  },
  failedToApproveRequest: {
    en: "Failed to approve the request",
    zh: "批准申请失败",
  },
  sampleRequestDeclined: {
    en: "Sample request declined",
    zh: "样品申请已拒绝",
  },
  failedToDeclineRequest: {
    en: "Failed to decline the request",
    zh: "拒绝申请失败",
  },
  changesRequestedSuccess: {
    en: "Changes requested",
    zh: "已要求修改",
  },
  failedToRequestChanges: {
    en: "Failed to request changes",
    zh: "要求修改失败",
  },
  changesSubmitted: {
    en: "Changes submitted",
    zh: "修改已提交",
  },
  failedToSubmitChanges: {
    en: "Failed to submit changes",
    zh: "提交修改失败",
  },
  submittedToManagement: {
    en: "Submitted to Management for approval",
    zh: "已提交管理层审批",
  },
  failedToSubmit: {
    en: "Failed to submit",
    zh: "提交失败",
  },
  failedToUploadAttachment: {
    en: "Failed to upload attachment",
    zh: "附件上传失败",
  },
  cadDrawingApproved: {
    en: "CAD drawing approved",
    zh: "CAD 图纸已批准",
  },
  failedToApproveCad: {
    en: "Failed to approve the CAD drawing",
    zh: "批准 CAD 图纸失败",
  },
  trackingNumberRequired: {
    en: "Tracking number is required",
    zh: "请填写运单号",
  },
  shippedDateFormatError: {
    en: "Shipped date must be DD/MM/YYYY",
    zh: "发货日期格式必须为 DD/MM/YYYY",
  },
  markedAsShipped: {
    en: "Marked as shipped",
    zh: "已标记为已发货",
  },
  failedToMarkAsShipped: {
    en: "Failed to mark as shipped",
    zh: "标记发货失败",
  },
  sampleRequestCompleted: {
    en: "Sample request completed",
    zh: "样品申请已完成",
  },
  failedToConfirmReceipt: {
    en: "Failed to confirm receipt",
    zh: "确认收货失败",
  },
  declinedCannotEdit: {
    en: "This request was declined and can no longer be edited",
    zh: "此申请已被拒绝，无法再编辑",
  },
  sampleRequestUpdated: {
    en: "Sample request updated",
    zh: "样品申请已更新",
  },
  failedToSaveChanges: {
    en: "Failed to save changes",
    zh: "保存更改失败",
  },
  couldNotReadSelectedFile: {
    en: "Could not read selected file",
    zh: "无法读取所选文件",
  },
  activityNewSampleRequestRaised: {
    en: "New sample request raised",
    zh: "已提交新的样品申请",
  },
  activityResubmittedWithChanges: {
    en: "Resubmitted the sample request with requested changes",
    zh: "已按要求修改并重新提交样品申请",
  },
  activityReviewedAndApproved: {
    en: "Reviewed and approved the sample request",
    zh: "已审核并批准样品申请",
  },
  activityFactorySubmittedForApproval: {
    en: "Factory submitted for Management approval",
    zh: "工厂已提交管理层审批",
  },
  activityApprovedCad: {
    en: "Approved CAD drawing",
    zh: "已批准 CAD 图纸",
  },
  activityEditedDetails: {
    en: "Edited the sample request details",
    zh: "已编辑样品申请详情",
  },
  activityConfirmedReceived: {
    en: "Confirmed the sample has been received",
    zh: "已确认收到样品",
  },
  activityRequestedChangesFromSales: {
    en: "Requested changes from Sales: {value}",
    zh: "已要求销售修改：{value}",
  },
  activityRequestedChangesFromChina: {
    en: "Requested changes from China: {value}",
    zh: "已要求中国团队修改：{value}",
  },
  activityShippedWithTracking: {
    en: "Shipped off the samples (tracking: {value})",
    zh: "样品已发出（运单号：{value}）",
  },
  declinedByManagement: {
    en: "This sample request was declined by Management.",
    zh: "此样品申请已被管理层拒绝。",
  },
};

export const customerOrderTrackerTranslationMap: Record<
  string,
  keyof typeof translations
> = {
  ReadyByDate: "readyByDate",
  OrderNumber1: "orderNumber",
  ItemCode: "itemCode",
  ItemName: "itemName",
  BPName: "customerName",
  OrderDate: "orderDate",
  TotalOrdered: "orderQty",
  progress: "progress",
  RequestDate: "requestDate",
  StateDelivery: "location",
  DaysLeft: "daysLeft",
  OrderStatus: "orderStatus",
  trackerActions: "actions",
  trackerActions_sm: "actions",
  NewDueDate: "newDueDate",
  NewOrderQty: "newOrderQty",
  NewShippingDeadline: "newShippingDeadline",
  Reject: "reject",
  Accept: "accept",
  CheckList: "checkList",
};

export const chinaTrackerTranslationMap: Record<
  string,
  keyof typeof translations
> = {
  Revise: "revise",
  ItemsSelected: "itemsSelected",
  CheckList: "checkList",
  TypeYourMessage: "typeYourMessage",
  EnterQuantity: "enterQuantity",
  Accept: "accept",
  Reject: "reject",
  RejectOrderNumber: "rejectOrderNumber",
  RequestDate: "requestDate",
  OrderNumber1: "orderNumber",
  ItemCode: "itemCode",
  ItemName: "itemName",
  BPName: "customerName",
  OrderDate: "orderDate",
  TotalOrdered: "orderQty",
  ETA: "eta",
  StateDelivery: "location",
  OrderStatus: "orderStatus",
  incomingStatus: "incomingStatus",
  PriorityOrder: "priorityOrder",
  MSRef: "msRef",
  MSNo: "msRef",
  ArtworkNo: "artworkNo",
  AllocateProductionLine: "allocateProductionLine",
  QtyToShip: "qtyToShip",
  FulfillmentPercent: "fulfillmentPercent",
  AusInventory: "ausInventory",
  actions: "actions",
  Actions: "actions",
  soakarPad: "soakarPad",
  directShipment: "directShipment",
  labelOrder: "labelOrder",
  Run: "Run",
  PlannedQty: "plannedQuantity",
  plannedQty: "plannedQuantity",
  allocateProductionLine: "allocateProductionLine",
  PlanStartDay: "planStartDay",
  planStartDay: "planStartDay",
  ActualStartDay: "actualStartDay",
  actualStartDay: "actualStartDay",
  ESTCompletion: "estCompletion",
  ESTCompletionDate: "estCompletion",
  ActualCompletionDate: "actualCompletionDate",
  actualCompletionDate: "actualCompletionDate",
  ExpectedArrival: "expectedArrival",
  ESTPack: "estPack",
  ESTPackDate: "estPack",
  ETD: "etd",
  ShippingDeadline: "shippingDeadline",
  shippingDeadline: "shippingDeadline",
  NewShippingDeadline: "newShippingDeadline",
  Customer: "customer",
  Item: "item",
  OrderPlaced: "orderPlaced",
  Subject: "subject",
  Priority: "priority",
  priority: "priority",
  Low: "low",
  High: "high",
  SelectPriority: "selectPriority",
  OrderIssue: "orderIssue",
  ProductInquiry: "productInquiry",
  Other: "other",
  SelectSubject: "selectSubject",
  Message: "message",
  POOrderDate: "poOrderDate",
  DueDate: "dueDate",
  NewDueDate: "newDueDate",
  NewOrderQty: "newOrderQty",
  State: "state",
  OrderQty: "orderQty",
  subject: "subject",
  createdAt: "createdAt",
  createdBy: "createdBy",
  message: "message",
  runOrder: "Run",
  // trackerActions: "actions",
  // trackerActions_sm: "actions",
  resolvedDate: "resolvedDate",
  createdByName: "createdByName",
  Duration: "duration",
  duration: "duration",
  chinaordernumber: "chinaordernumber",
  interruptType: "interruptType",
  interruptedBy: "interruptedBy",
};

export const chinaShipmentTranslationMap: Record<
  string,
  keyof typeof translations
> = {
  status: "statusLabel",
  BPName: "customerName",
  containerNo: "containerNo",
  totalQty: "totalShippedQty",
  updatedAt: "lastUpdate",
  itemCount: "totalItems",
  location: "location",
  ETD: "etd",
  ETA: "eta",
  shippingLine: "shippingLine",
  sealNo: "sealNo",
  generatedBy: "generatedBy",
  createdAt: "createdAt",
  gwTotal: "gwTotal",
  nwTotal: "nwTotal",
  itemCode: "itemCode",
  qtyTotal: "Qty",
  orderNumber: "orderNumber",
  fromStock: "stockSplitLabel",
  Accept: "accept",
  chinaItemCode: "chinaItemCode",
  globalItemCode: "globalItemCode",
  approvedBy: "approvedBy",
  vesselVoyage: "vesselVoyage",
  freightLine: "freightLine",
  itemDescription: "itemName",
  material: "material",
  spec: "spec",
  label: "label",
  quantity: "quantity",
  grossWeight: "grossWeight",
  netWeight: "netWeight",
  notes: "notes",
  generateShipment: "generateShipment",
  orderNo: "orderNumber",
  itemName: "itemName",
  shipmentQty: "Qty",
  orderDate: "orderDate",
  requestDate: "requestDate",
};

export const stockReportTranslationMap: Record<
  string,
  keyof typeof translations
> = {
  Location: "location",
  ItemCode: "itemCode",
  ItemName: "itemName",
  FrgnName: "itemDescription",
  CardName: "customerName",
  PerCtns: "pcsCarton",
  PerPallet: "ctnsPerPallet",
  Available2: "available",
  AvaliablePallet: "availablePallet",
  OnWater: "inTransit",
  OnOrder2: "onOrder",
  OnHand: "onHand",
  Delivery: "delivery",
  Reserved: "reserved",
  OrderReserved: "orderReserved",
  "Inventory Transferring": "transferringIn",
};

export const productReportTranslationMap: Record<
  string,
  keyof typeof translations
> = {
  ItemCode: "itemCode",
  ItemName: "itemName",
  FrgnName: "itemDescription",
  CardName: "customerName",
  PerCtns: "pcsCarton",
  PerPallet: "ctnsPerPallet",
};

export const customerStatusTranslationMap: Record<
  string,
  keyof typeof translations
> = {
  AccountStatus: "accountStatus",
  CardCode: "customerCode",
  CardName: "customerName",
  PymntGroup: "paymentGroup",
  CreditLine: "creditLine",
  Variance: "variance",
  Balance: "balance",
  OpenDeliveries: "openDeliveries",
  CommittedOrders: "committedOrders",
  SlpName: "sales",
};

export const customerOrderTranslationMap: Record<
  string,
  keyof typeof translations
> = {
  PONum: "poNumber",
  MSNum: "msNumber",
  OrderDate: "orderDate",
  PODueDate: "poDueDate",
  POWeekNo: "poWeekNo",
  POStatus: "poStatus",
  OrderStatus: "orderStatus",
  ContainerNo: "containerNo",
  ETDDate: "etdDate",
  ETAPort: "etaPort",
  ETAStore: "etaStore",
  DeliveredDate: "deliveredDate",
  ShippedQty: "shippedQty",
  ShippedQtyCtn: "shippedQtyCtn",
  QtytoShip: "qtyToShip",
  QtytoShip2: "qtyToShip2",
  QtytoShipCtn: "qtyToShipCtn",
  Followup: "followUp",
  ItmsGrpNam: "itmsGrpNam",
  ItemName: "itemName",
  Labeltype: "labelType",
  ItemGroup: "itemGroup",
  PackQty: "packQty",
  OrderedQty: "orderedQty",
  OrderedQtyCtn: "orderedQtyCtn",
  TotalShippedQty: "totalShippedQty",
  TotalShippedQtyCtn: "totalShippedQtyCtn",
  State: "state",
  CustomerCode: "customerCode",
  CustomerName: "customerName",
  ShipToAddress: "shipToAddress",
  PORemarks: "poRemarks",
  SODueDate: "soDueDate",
  OperationRemark: "operationRemarks",
  CardName: "customerName",
  PymntGroup: "paymentGroup",
  CreditLine: "creditLine",
  Variance: "variance",
  Balance: "balance",
  OpenDeliveries: "openDeliveries",
  CommittedOrders: "committedOrders",
};

export const deliveryReportTranslationMap: Record<
  string,
  keyof typeof translations
> = {
  State: "state",
  Warehouse: "warehouse",
  DocNum: "documentNo",
  CustomerPortalOrderNo: "portalOrderNo",
  ItemCode: "itemCode",
  Dscription: "description",
  DeliveryAddress: "address",
  ProductGroup: "productGroup",
  RemainingQty: "remainingQty",
  CustomerCode: "customerCode",
  CustomerName: "customerName",
  DocType: "document",
  OrderStatus: "orderStatus",
  RequestDate: "requestDate",
  ShippingType: "shippingType",
  ShipToCode: "shippingCode",
  PaymentTerm: "payment",
  SalesPerson: "sales",
  SOOperator: "operator",
};

export const pmxInventoryTranslationMap: Record<
  string,
  keyof typeof translations
> = {
  ItemCode: "itemCode",
  ItemName: "itemName",
  Location: "location",
  QuantityUom: "uom1",
  QuantityUom2: "uom2",
  BatchNumber1: "batchNumber",
  SsccNumber: "ssccNumber",
  QuantityStatus: "status",
  StorLocName: "aisle",
};

export const productionStockTranslationMap: Record<
  string,
  keyof typeof translations
> = {
  ItemCode: "itemCode",
  ProdCode: "productCode",
  ItemName: "itemName",
  FrgnName: "itemDescription",
  InStock: "available",
  Committed: "committed",
  Required: "required",
  OnOrder: "ordered",
  Planned: "planned",
};

export const rawMaterialTranslationMap: Record<
  string,
  keyof typeof translations
> = {
  FrgnName: "rawMaterialGroup",
  TotalInstock: "total",
  aPET: "aPET",
  rPET50: "rPET50",
  rPET80: "rPET80",
  rPET100: "rPET100",
};

export const rawMaterialOverviewTranslationMap: Record<
  string,
  keyof typeof translations
> = {
  RawMaterialOverview: "rawMaterial",
  TotalInStock: "total",
  PlannedQty: "planned",
  OnWater: "onWater",
  OnOrder: "onOrder",
};

export const sampleRequestTranslationMap: Record<
  string,
  keyof typeof translations
> = {
  requestId: "requestId",
  createdAt: "sampleRequestCreatedDate",
  itemName: "itemName",
  customer: "customer",
  purpose: "purpose",
  sampleQtyNeeded: "qty",
  toolingCost: "toolingCost",
  status: "status",
  requestedBy: "requestedBy",
  All: "all",
  "Pending Approval": "pendingApproval",
  "Changes Requested": "changesRequested",
  "Sent to Factory": "sentToFactory",
  "Reviewing CAD": "reviewingCad",
  "CAD Changes Requested": "cadChangesRequested",
  "In Production": "inProduction",
  Shipped: "shipped",
  Completed: "sampleStatusCompleted",
  Declined: "declined",
  "New Customer": "purposeNewCustomer",
  "Customer trials or testing": "purposeCustomerTrials",
  "Multisteps warehouse usage (samples out of stock)": "purposeWarehouseUsage",
  "New Sample Customer": "purposeNewSampleCustomer",
  "Depth or material change": "purposeDepthMaterialChange",
  "Colour matching": "purposeColourMatching",
  "Wall thickness change": "purposeWallThicknessChange",
  Other: "other",
  Sales: "roleSales",
  Management: "roleManagement",
  China: "roleChina",
  Production: "roleProduction",
  System: "roleSystem",
  "New sample request raised": "activityNewSampleRequestRaised",
  "Resubmitted the sample request with requested changes":
    "activityResubmittedWithChanges",
  "Reviewed and approved the sample request": "activityReviewedAndApproved",
  "Factory submitted for Management approval":
    "activityFactorySubmittedForApproval",
  "Approved CAD drawing": "activityApprovedCad",
  "Confirmed the sample has been received": "activityConfirmedReceived",
  "Edited the sample request details": "activityEditedDetails",
};


export const sampleRequestActivityPatterns: Array<{
  pattern: RegExp;
  key: keyof typeof translations;
}> = [
    {
      pattern: /^Requested changes from Sales: ([\s\S]*)$/,
      key: "activityRequestedChangesFromSales",
    },
    {
      pattern: /^Requested changes from China: ([\s\S]*)$/,
      key: "activityRequestedChangesFromChina",
    },
    {
      pattern: /^Shipped off the samples \(tracking: ([\s\S]*)\)$/,
      key: "activityShippedWithTracking",
    },
  ];

export const scoreCardTranslationMap: Record<
  string,
  keyof typeof translations
> = {
  Dashboard: "dashboard",
  Usage: "usage",
  Value: "value",
  InvoiceDN: "invoicedn",
  "Invoice Date": "invoiceDate",
  "Invoice Number": "invoiceNo",
  "Invoice No.": "invoiceNo",
  "DN Number": "dnNo",
  "DN No.": "dnNo",
  "DN Number Invoice Value": "valueUsd",
  "Value ($)": "valueUsd",
  "DN Number Invoice Quantity": "qty",
  "DN Delivery Suburb": "deliverySuburb",
  "Delivery Suburb": "deliverySuburb",
  Year: "year",
  "Invoice Month": "monthShort",
  Mth: "monthShort",
  "Dispatch State": "dispatchState",
  "Dispatch St.": "dispatchSt",
  "Delivery State": "deliveryState",
  "Delivery St.": "deliverySt",
  "Item Group": "itemGroup",
  "Item Name": "itemName",
  Customer: "customerName",
  "Sales Person": "salesPerson",
  FILTERS: "filters",
  Total: "total",
  "Calendar Year": "calendarYear",
  "End of Financial Year": "financialYear",
  "Sales Scorecard - Year On Year Usage": "salesScorecardYoYUsage",
  "Sales Scorecard - Financial Year": "salesScorecardFinancialYear",
};

export const reserveStockTranslationMap: Record<
  string,
  keyof typeof translations
> = {
  DocNum: "orderNumber",
  CardCode: "customerCode",
  CardName: "customerName",
  Address2: "address",
  WhsName: "warehouse",
  ItemCode: "itemCode",
  Dscription: "itemDescription",
  "Open Qty PCS": "Order Reserved",
  SlpName: "sales",
  "Order Date": "orderDate",
  "Valid until": "validUntil",
  "Doc Status": "docStatus",
};

export const productionTranslationMap: Record<
  string,
  keyof typeof translations
> = {
  operation: "operation",
  workcenter: "workCenter",
  mo: "manufacturingOrder",
  customerReference: "customerReference",
  product: "product",
  qty: "quantityRequired",
  startDate: "startDate",
  endDate: "endDate",
  startTime: "startTime",
  endTime: "endTime",
  expected: "expectedDuration",
  duration: "durationMinutes",
  status: "status",
};
